
import React, { useEffect, useState,useCallback,useRef } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import i18n from './i18n';
import { useParams, useLocation,useNavigate } from 'react-router-dom';
// import longSocket from './longSocket'; 
import longSocket, {
  rememberLongRoom,
  clearLongRoom,
  ensureLongSocketAuthAndConnect
} from './khachapuriSocket';
import KhachapuriBoardDisplay from './KhachapuriBoardDisplay'; // Дочерний компонент отрисовки
import { useGame } from './context/GameContext';






// ======== БАЗОВАЯ МОДАЛКА =========
const ModalBase = ({ open, children }) => {
  if (!open) return null;

  const modalNode = (
    <div
      className="khachapuri-confirm-mask"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 2147483647,
        background: 'rgba(0,0,0,0.72)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        padding: 'max(12px, env(safe-area-inset-top)) max(12px, env(safe-area-inset-right)) max(12px, env(safe-area-inset-bottom)) max(12px, env(safe-area-inset-left))',
        overflowY: 'auto',
        overscrollBehavior: 'contain',
        pointerEvents: 'auto'
      }}
      onPointerDown={(event) => event.stopPropagation()}
      onClick={(event) => event.stopPropagation()}
    >
      <div
        className="khachapuri-confirm-dialog"
        style={{
          width: 'min(420px, calc(100vw - 24px))',
          maxWidth: '420px',
          maxHeight: 'calc(100dvh - 24px)',
          overflowY: 'auto',
          boxSizing: 'border-box',
          background: '#121212',
          color: '#fff',
          borderRadius: 12,
          padding: 20,
          boxShadow: '0 10px 30px rgba(0,0,0,.55)'
        }}
      >
        {children}
      </div>
    </div>
  );

  return typeof document !== 'undefined'
    ? createPortal(modalNode, document.body)
    : modalNode;
};

// ======== ИНФО-МОДАЛКА (вместо alert) =========
const InfoModal = ({
  open, title = i18n.t('game.long.messageTitle'), message = '',
  primaryText = i18n.t('game.common.ok'), onPrimary = () => {}
}) => (
  <ModalBase open={open}>
    <div style={{fontSize: 18, fontWeight: 700, marginBottom: 8}}>{title}</div>
    <div style={{opacity: .9, lineHeight: 1.4, whiteSpace: 'pre-wrap'}}>{message}</div>
    <div style={{display:'flex', justifyContent:'flex-end', gap: 8, marginTop: 16}}>
      <button
        onClick={onPrimary}
        style={{
          padding: '8px 14px', borderRadius: 10, border: 'none',
          background: '#2e7d32', color: '#fff', cursor: 'pointer'
        }}
      >
        {primaryText}
      </button>
    </div>
  </ModalBase>
);

// ======== CONFIRM-МОДАЛКА (вместо confirm) =========
const ConfirmModal = ({
  open, title = i18n.t('game.long.confirmTitle'), message = '',
  confirmText = i18n.t('game.common.yes'), cancelText = i18n.t('game.common.cancel'),
  onConfirm = () => {}, onCancel = () => {}
}) => (
  <ModalBase open={open}>
    <div style={{fontSize: 18, fontWeight: 700, marginBottom: 8}}>{title}</div>
    <div style={{opacity: .9, lineHeight: 1.4, whiteSpace: 'pre-wrap'}}>{message}</div>
    <div style={{display:'flex', justifyContent:'flex-end', gap: 8, marginTop: 16}}>
      <button
        onClick={onCancel}
        style={{
          minHeight: 46,
          minWidth: 96,
          padding: '10px 16px', borderRadius: 10, border: '1px solid #555',
          background: 'transparent', color: '#ddd', cursor: 'pointer',
          touchAction: 'manipulation'
        }}
      >
        {cancelText}
      </button>
      <button
        onClick={onConfirm}
        style={{
          minHeight: 46,
          minWidth: 96,
          padding: '10px 16px', borderRadius: 10, border: 'none',
          background: '#c62828', color: '#fff', cursor: 'pointer',
          touchAction: 'manipulation'
        }}
      >
        {confirmText}
      </button>
    </div>
  </ModalBase>
);


const Khachapuri = () => {
  const { t: translate } = useTranslation();
const {blockStol, setBlockStol} = useGame() 
  const { tableId } = useParams();
  


  
  // Основные стейты
  const [username, setUsername] = useState('');
  // const [longBoardState, setLongBoardState] = useState(Array(24).fill([]));
  const [longBoardState, setLongBoardState] = useState(
  Array.from({ length: 24 }, () => [])
);
 
  // const [longBoard, setLongBoard] = useState([]);
  const [longWhiteOffBoard, setLongWhiteOffBoard] = useState([]);
  const [longBlackOffBoard, setLongBlackOffBoard] = useState([]);
  const [longMyColor, setLongMyColor] = useState('white');
  const [longCurrentTurn, setLongCurrentTurn] = useState(null);
  const [longDiceValues, setLongDiceValues] = useState([]);
  const [longNumberMove, setLongNumberMove] = useState(0);
  const [longFirstRolls, setLongFirstRolls] = useState(null);
  const [longFirstMoveComplete, setLongFirstMoveComplete] = useState(false);
  const [longFirstComplete, setLongFirstRollComplete] = useState(false);
  const [longRolledDice, setLongRolledDice] = useState([]);
  const [longOpponentColor, setLongOpponentColor] = useState(null);
  const [longHasRolledDice, setLongHasRolledDice] = useState(false);
  const [longRollEnabled, setLongRollEnabled] = useState(false);
  const [longUsedRolls, setLongUsedRolls] = useState([]); // Добавляем это состояние
  const [longPlayer1Name, setLongPlayer1Name] = useState('');
  const [longPlayer2Name, setLongPlayer2Name] = useState('');
 const [longDisableBoardClicks, setLongDisableBoardClicks] = useState(false);
 const [longLastMoveType, setLongLastMoveType] = useState(null); // 'click' или 'drag'
  // Для отката ходов
  const [longMoveHistory, setLongMoveHistory] = useState([]);
  const [longShowUndoButton, setLongShowUndoButton] = useState(false);
  const [diceColorForRender, setDiceColorForRender] = useState(null);
  const navigate = useNavigate();
  // Для состояния загрузки/ошибки
  const [longLoading, setLongLoading] = useState(true);
  const [longError, setLongError] = useState('');
  const [longPlayerColor, setLongPlayerColor] = useState('');
  const [headMoveCount, setHeadMoveCount] = useState(0);
const [headCheckersMoved, setHeadCheckersMoved] = useState(0)
const justConfirmedRef = useRef(false);
const headInitialCountRef = useRef(null);
const hasFetchedRef = useRef(false);
const [rolledByPlayer, setRolledByPlayer] = useState(null); // 'player1' | 'player2'
const [currentMultiplier, setCurrentMultiplier] = useState(1);
const [lastDoubler, setLastDoubler] = useState(null);
const [initialBet, setInitialBet] = useState(1);
const [maxBet, setMaxBet] = useState(0);
const [doubleProposal, setDoubleProposal] = useState(null);
const [cubeOwner,      setCubeOwner]      = useState(null); // null | username
const [betMultiplier,  setBetMultiplier]  = useState(1);
const [waitingDoubleReply, setWaitingDoubleReply] = useState(false); 
const [isCrawfordGame, setIsCrawfordGame] = useState(false);

// ===== счёт матча (best‑of‑N) =========================
const [matchScore,   setMatchScore]   = useState([0, 0]); // [player1, player2]
// В Хачапури targetPoints фактически означает ОБЩЕЕ КОЛИЧЕСТВО ПАРТИЙ.
const [targetPoints, setTargetPoints] = useState(1);
const [currentGameNumber, setCurrentGameNumber] = useState(1); // 1/5, 2/5, ...


const [longPlayer1Rating, setLongPlayer1Rating] = useState(null);
const [longPlayer2Rating, setLongPlayer2Rating] = useState(null);


const [surenderExit, setSurenderExit] = useState(false); 
const ratingsMapRef = useRef(null);


const [longPlayer1Avatar, setLongPlayer1Avatar] = useState('');
const [longPlayer2Avatar, setLongPlayer2Avatar] = useState('');

// ======================================================

const redirectTimerRef = useRef(null);
const didScheduleRedirectRef = useRef(false);

// ==== Таймеры (секунды) =====================================
const [longPlayer1Time, setLongPlayer1Time] = useState(300);
const [longPlayer2Time, setLongPlayer2Time] = useState(300);

const [autoRoll, setAutoRoll] = useState(false);
const [autoConfirm, setAutoConfirm] = useState(false);

// Модалки (вместо alert/confirm)
const [infoModal, setInfoModal] = useState({
  open: false, title: '', message: '', primaryText: i18n.t('game.common.ok'), onPrimary: null
});
const [showSurrenderModal, setShowSurrenderModal] = useState(false);



/* helper для рендера вида 02:59 */
const formatSec = (sec) => {
  const m = String(Math.floor(sec / 60)).padStart(2, '0');
  const s = String(sec % 60).padStart(2, '0');
  return `${m}:${s}`;
};



const API_ORIGIN =
  (import.meta?.env?.VITE_API_ORIGIN) ||
  (process.env.REACT_APP_API_URL) ||
  '';
const API_BASE = API_ORIGIN ? `${API_ORIGIN}/api` : '/api';
const pathAbs = (p) => {
  if (!p) return '';
  const s = String(p).replace(/\\/g, '/');
  return s.startsWith('/') ? s : `/${s}`;
};

 const [longInitialRollPhase, setLongInitialRollPhase] = useState(false);

  const location = useLocation();
  const { id: longGameId } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const longTableId = queryParams.get('tableId');
  const longUsername = localStorage.getItem('username') || '';
  const isSpectator = queryParams.get('spectator') === '1';



  const [longGameResult, setLongGameResult] = useState(null);
  const [showLongResultModal, setShowLongResultModal] = useState(false);
  const [doubleJustTaken, setDoubleJustTaken] = useState(false);

  // ==============================
  // Подключаемся / запрашиваем игру
  // ==============================


useEffect(() => {
 console.log('453345453',doubleProposal);
 
}, [doubleProposal]);







useEffect(() => {
  let cancelled = false;
  (async () => {
    try {
      const res = await fetch(`${API_BASE}/auth/users-with-ratings`);
      const list = await res.json();
      if (cancelled) return;
      ratingsMapRef.current = new Map(
        list.map(u => [u.username, { short: u.short_rating, long: u.long_rating }])
      );
      // сразу попробуем обновить, если имена уже известны
      updateRatings();
    } catch (e) {
      console.warn('[ratings] fetch error', e);
    }
  })();
  return () => { cancelled = true; };
}, []);


const updateRatings = useCallback(() => {
  const map = ratingsMapRef.current;
  if (!map) return;
  setLongPlayer1Rating(map.get(longPlayer1Name)?.long ?? null);
  setLongPlayer2Rating(map.get(longPlayer2Name)?.long ?? null);
}, [longPlayer1Name, longPlayer2Name]);

useEffect(() => { updateRatings(); }, [updateRatings]);


useEffect(() => {
  // При смене хода сбрасываем фиксированное начальное значение для головы
  headInitialCountRef.current = null;
  setHeadMoveCount(0);
  setHeadCheckersMoved(0)
}, [longCurrentTurn]);



// Обработчик предложения удвоения
useEffect(() => {
  /** сервер шлёт: { by:string, newMultiplier:number, cubeOwner:string|null } */
  function handleDoubleProposed({ by, newMultiplier, cubeOwner }) {
    const me = localStorage.getItem('username');

    if (by === me) {                     // ← это я предложил
      // просто ждём ответа, окно нам не нужно
      
      return;
    }

    /* игрок‑оппонент: показываем окно + блокируем доску */
    setDoubleProposal({ by, newMultiplier });
    setLongDisableBoardClicks(true);
  }

  longSocket.on('long_doubleProposed', handleDoubleProposed);
  return () => longSocket.off('long_doubleProposed', handleDoubleProposed);
}, []);












useEffect(() => {
  function handleScoreUpdate(p) {
    if (String(p.tableId) !== String(tableId)) return;

    if (Array.isArray(p.score)) setMatchScore([+p.score[0], +p.score[1]]);
    if (p.targetPoints != null) setTargetPoints(+p.targetPoints);

    // scoreUpdate приходит в конце текущей партии.
    // Пока показываем её номер; следующий roundReset переключит на 2/5, 3/5 и т.д.
    if (p.roundNumber != null) {
      const n = Number(p.roundNumber);
      if (Number.isFinite(n) && n > 0) setCurrentGameNumber(Math.floor(n));
    }

    if (typeof p.isCrawford === 'boolean') setIsCrawfordGame(p.isCrawford);
  }

  longSocket.on('long_scoreUpdate', handleScoreUpdate);
  return () => longSocket.off('long_scoreUpdate', handleScoreUpdate);
}, [tableId]);





useEffect(() => {
  // Делает URL абсолютным только если он относительный
  const absolutize = (raw) => {
    if (!raw) return null;
    const s = String(raw).trim();
    if (/^https?:\/\//i.test(s) || /^data:/i.test(s)) return s;      // уже абсолютный
    return `${API_ORIGIN}${pathAbs(s)}`;                              // относительный → дополняем
  };

  const onResult = (data) => {
    console.log('[Client] long_game_result:', data);

    // ❗️Главное изменение — убрали двойное префиксование API_ORIGIN
    data.winnerAvatar = absolutize(data.winnerAvatar) || '/img/default-avatar.png';
    data.loserAvatar  = absolutize(data.loserAvatar)  || '/img/default-avatar.png';

    if (Array.isArray(data.finalScore)) {
      setMatchScore([+data.finalScore[0], +data.finalScore[1]]);
    }
    if (data.targetPoints != null) setTargetPoints(+data.targetPoints);

    // Синхронизируем баланс в общей шапке сразу для ОБОИХ игроков.
    // Раньше LongBoardDisplay делал это только для победителя.
    try {
      const me = (localStorage.getItem('username') || '').trim();
      let nextBalance = null;

      if (me && me === String(data.winnerUsername || '').trim()) {
        nextBalance = Number(data.updatedWinnerBalance);
      } else if (me && me === String(data.loserUsername || '').trim()) {
        nextBalance = Number(data.updatedLoserBalance);
      }

      if (Number.isFinite(nextBalance)) {
        window.dispatchEvent(
          new CustomEvent('balance-updated', { detail: { balance: nextBalance } })
        );
      }
    } catch (_) {}

    setLongGameResult(data);
    setShowLongResultModal(true);
    setLongDisableBoardClicks(true);
    setLongRollEnabled(false);
  };

  longSocket.on('long_game_result', onResult);
  return () => longSocket.off('long_game_result', onResult);
}, []);


// useEffect(() => {
//   longSocket.on('long_game_result', (data) => {
//     console.log('[Client] long_game_result:', data);
//    data.winnerAvatar = data.winnerAvatar
//    ? `${API_ORIGIN}${pathAbs(data.winnerAvatar)}`
//    : '/img/default-avatar.png';
//  data.loserAvatar = data.loserAvatar
//    ? `${API_ORIGIN}${pathAbs(data.loserAvatar)}`
//    : '/img/default-avatar.png';



//    if (Array.isArray(data.finalScore)) setMatchScore([+data.finalScore[0], +data.finalScore[1]]);
//     if (data.targetPoints != null) setTargetPoints(+data.targetPoints);
  
//     setLongGameResult(data);
//     setShowLongResultModal(true);
//     setLongDisableBoardClicks(true);
//     setLongRollEnabled(false);
//   });

//   return () => {
//     longSocket.off('long_game_result');
//   };
// }, []);





const normUrl = React.useCallback((v) => {
  if (!v) return '';
  const s = String(v);
  if (/^https?:\/\//i.test(s)) {
    // переписываем localhost/127.0.0.1 на прод-базу
    return s.replace(
      /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i,
      API_ORIGIN
    );
  }
  // относительный путь → приклеиваем базу API
  return `${API_ORIGIN}${pathAbs(s)}`;
}, [API_ORIGIN]);








// const maxHeadCheckers = (headCountBefore, dice) => {
//   const isSpecialDouble =
//     dice.length === 2 &&
//     dice[0] === dice[1] &&
//     [3, 4, 6].includes(dice[0]);
//   return headCountBefore === 15 && isSpecialDouble ? 2 : 1;
// };
// ХАЧАПУРИ:
// обычный бросок позволяет снять с головы до 2 РАЗНЫХ шашек,
// куш — до 4 РАЗНЫХ шашек. Ограничения длинных нард здесь нет.
const maxHeadCheckers = (_headCountBefore, dice) => {
  const isDouble =
    Array.isArray(dice) &&
    dice.length >= 2 &&
    dice[0] === dice[1];

  return isDouble ? 4 : 2;
};
 

function safeParseBoard(raw) {
  try {
    const board = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (!Array.isArray(board) || board.length !== 24) throw new Error('invalid board');

    // убедимся, что каждая точка — это массив
    return board.map(point => Array.isArray(point) ? point : []);
  } catch (e) {
    console.error('[safeParseBoard] Ошибка при парсинге:', e);
    return Array.from({ length: 24 }, () => []);
  }
}




const khachapuriOpeningRef = React.useRef({
  active: false,
  tableId: null,
  round: 1,
  starter: null,
  dice: [],
  numberMove: 0,
});


const handleKhachapuriRoundStart = useCallback((data = {}) => {
  if (!data) return;

  const dice = Array.isArray(data.dice)
    ? data.dice.map(Number).slice(0, 2)
    : [];

  const d1 = dice[0];
  const d2 = dice[1];

  if (
    !Number.isInteger(d1) || d1 < 1 || d1 > 6 ||
    !Number.isInteger(d2) || d2 < 1 || d2 > 6
  ) {
    console.warn('[KHACHAPURI] Некорректный dedicated round roll:', data);
    return;
  }

  const starter =
    data.starter === 'player2'
      ? 'player2'
      : 'player1';

  const me = String(
    localStorage.getItem('username') || username || ''
  ).trim();

  const p1Name = String(
    data.player1_name || data.player1Name || longPlayer1Name || ''
  ).trim();

  const p2Name = String(
    data.player2_name || data.player2Name || longPlayer2Name || ''
  ).trim();

  let myRole = null;

  if (!isSpectator) {
    if (me && p1Name && me === p1Name) {
      myRole = 'player1';
      setLongMyColor('white');
    } else if (me && p2Name && me === p2Name) {
      myRole = 'player2';
      setLongMyColor('black');
    } else {
      myRole = longMyColor === 'black' ? 'player2' : 'player1';
    }
  }

  const numberMove =
    Number.isFinite(Number(data.numberMove)) && Number(data.numberMove) > 0
      ? Number(data.numberMove)
      : (d1 === d2 ? 4 : 2);

  khachapuriOpeningRef.current = {
    active: true,
    tableId: Number(data.tableId || tableId || 0) || null,
    round: Math.max(1, Number(data.round || 1)),
    starter,
    dice: [d1, d2],
    numberMove,
  };

  console.log('[KHACHAPURI][ROUND_START][CLIENT]', {
    me,
    tableId: khachapuriOpeningRef.current.tableId,
    round: khachapuriOpeningRef.current.round,
    starter,
    dice: [d1, d2],
    numberMove,
    replay: !!data.replay,
  });

  setRolledByPlayer(starter);

  /*
   * В Хачапури это НЕ "один кубик белому + один чёрному".
   * Это обычные два кубика ОДНОГО стартующего игрока.
   *
   * Поэтому longFirstRolls намеренно null:
   * KhachapuriBoardDisplay отрисует longRolledDice как обычные кубики
   * цвета currentTurn, а не белый+чёрный как в длинном opening roll.
   */
  setLongFirstRolls(null);
  setLongRolledDice([d1, d2]);
  setLongCurrentTurn(starter);
  setLongFirstRollComplete(true);
  setLongFirstMoveComplete(false);
  setLongRollEnabled(false);
  setSurenderExit(true);

  if (isSpectator) {
    setLongHasRolledDice(true);
    setLongDiceValues([]);
    setLongNumberMove(0);
    setLongDisableBoardClicks(true);
    return;
  }

  const isMyTurn = myRole === starter;

  if (isMyTurn) {
    setLongHasRolledDice(true);
    setLongDiceValues(diceArrayFromRoll([d1, d2]));
    setLongNumberMove(numberMove);
    setLongDisableBoardClicks(false);
  } else {
    // Второй игрок видит те же два кубика, но ждёт своего хода.
    setLongHasRolledDice(true);
    setLongDiceValues([]);
    setLongNumberMove(0);
    setLongDisableBoardClicks(true);
  }
}, [
  isSpectator,
  username,
  longPlayer1Name,
  longPlayer2Name,
  longMyColor,
]);


const khachapuriRoundStartHandlerRef = React.useRef(handleKhachapuriRoundStart);

useEffect(() => {
  khachapuriRoundStartHandlerRef.current = handleKhachapuriRoundStart;
}, [handleKhachapuriRoundStart]);


useEffect(() => {
  if (!longSocket) return;

  const onKhachapuriRoundStart = (payload) => {
    khachapuriRoundStartHandlerRef.current?.(payload);
  };

  // Dedicated событие Хачапури.
  // long_autoLongFirstRoll здесь больше НЕ используется.
  longSocket.on('khachapuri_roundStart', onKhachapuriRoundStart);

  return () => {
    longSocket.off('khachapuri_roundStart', onKhachapuriRoundStart);
  };
}, [longSocket]);


// useEffect(() => {
//   if (!longMyColor) return;                 // цвет ещё не узнали — ждём
//   longSocket.on('long_autoLongFirstRoll', handleAutoLongFirstRoll);

//  setSurenderExit(true)



//   return () => {
//     longSocket.off('long_autoLongFirstRoll', handleAutoLongFirstRoll);
//   };
// }, [handleAutoLongFirstRoll]);     


useEffect(() => {
  const handleGameFinished = () => {
    /*
     * ХАЧАПУРИ:
     * маленькое промежуточное окно
     * "Партия завершена / Вы выиграли / Вы проиграли"
     * больше НЕ показываем.
     *
     * Большая итоговая result-modal остаётся и открывается
     * отдельным событием long_game_result.
     */
    setLongDisableBoardClicks(true);
    setLongRollEnabled(false);
    setLongHasRolledDice(true);
  };

  longSocket.once('long_gameFinished', handleGameFinished);
  return () => {
    longSocket.off('long_gameFinished', handleGameFinished);
  };
}, []);







useEffect(() => {
  if (!showLongResultModal) return;
  if (didScheduleRedirectRef.current) return;

  didScheduleRedirectRef.current = true;

  // кто я
  const me = (username || localStorage.getItem('username') || '').trim();
  const loserName  = longGameResult?.loserUsername || longGameResult?.loser || '';
  const winnerName = longGameResult?.winnerUsername || longGameResult?.winner || '';

  // показывать ли «полосу удачи» мне
  const shouldOpenCashBarForMe = !!me && !isSpectator && me === loserName;

  // payload для лобби (прокидываем ТОЛЬКО проигравшему)
  const fortunePayload = {
    start: true,
    gameType: 'khachapuri',
    tableId: Number(tableId),
    winner: winnerName,
    loser: loserName,
    betMultiplier,
    initialBet,
    finalStake: longGameResult?.finalStake,
    winnerAmount: longGameResult?.winnerAmount,
  };

  // redirectTimerRef.current = setTimeout(() => {
  //   // уведомим сервер, что выходим
  //   console.log('12345');
    
  //   longSocket.emit('longLeaveTable', {
  //     tableId: Number(tableId),
  //     player: username,
  //   });

  //   // редирект в лобби:
  //   //  - проигравший: с state.cashBar → откроется полоса удачи
  //   //  - остальные (победитель/зрители): просто редирект без полосы
  //   navigate('/', {
  //     replace: true,
  //     state: shouldOpenCashBarForMe ? { cashBar: fortunePayload } : undefined,
  //   });
  // }, 15000);
    redirectTimerRef.current = setTimeout(() => {
    // ⬇️ ДОБАВЬ ЭТО
    try {
      localStorage.removeItem('currentTableId');
      localStorage.removeItem(`khachapuri:snap:${tableId}`);
    } catch (_) {}

    // уведомим сервер, что выходим
    console.log('12345');
    
    longSocket.emit('longLeaveTable', {
      tableId: Number(tableId),
      player: username,
    });

    navigate('/', {
      replace: true,
      state: shouldOpenCashBarForMe ? { cashBar: fortunePayload } : undefined,
    });
  }, 15000);


  return () => {
    if (redirectTimerRef.current) clearTimeout(redirectTimerRef.current);
  };
}, [
  showLongResultModal,
  navigate,
  tableId,
  username,
  isSpectator,
  longGameResult,
  betMultiplier,
  initialBet
]);





useEffect(() => {
  if (isSpectator) {
    setLongDisableBoardClicks(true);
    setLongRollEnabled(false);
  }
}, []);




// ─────────────────────────────────────────────────────────────
//  Снятие шашки (bear‑off)  ***ИСПОЛЬЗУЕТСЯ и для drag&drop, и для click***
// ─────────────────────────────────────────────────────────────
const performBearOff = (fromIdx, dieVal) => {
  /* 0.  Снимем копии «до»‑состояния для истории (undo) */
  const boardBefore        = deepCopyBoard(longBoardState);
  const prevWhiteOffBefore = [...longWhiteOffBoard];
  const prevBlackOffBefore = [...longBlackOffBoard];

  /* 1.  Копируем доску и снимаем верхнюю шашку из пункта fromIdx */
  const nextBoard = deepCopyBoard(longBoardState);
  const checker   = nextBoard[fromIdx].pop();              // именно та шашка, которую снимаем

  /* 2.  Формируем ***новые*** массивы off‑board — они нужны и setState‑у, и emit‑у */
  let nextWhiteOff = [...longWhiteOffBoard];
  let nextBlackOff = [...longBlackOffBoard];

  if (longMyColor === 'white') {
    nextWhiteOff = [...nextWhiteOff, checker];             // белая шашка уходит в белый «off»
  } else {
    nextBlackOff = [...nextBlackOff, checker];             // чёрная — в чёрный «off»
  }

  /* 3.  Обновляем React‑состояние (setState) уже готовыми массивами */
  setLongWhiteOffBoard(nextWhiteOff);
  setLongBlackOffBoard(nextBlackOff);
  setLongBoardState(nextBoard);

  /* 4.  Сохраняем шаг в историю для кнопки «Undo» */
  setLongMoveHistory(prev => [
    ...prev,
    {
      type              : 'bearOff',
      from              : fromIdx,
      boardBefore,
      prevWhiteOffBoard : prevWhiteOffBefore,
      prevBlackOffBoard : prevBlackOffBefore,
      prevDiceValues    : [...longDiceValues],
      prevNumberMove    : longNumberMove
    }
  ]);
  setLongLastMoveType('bearOff');

  /* 5.  Корректируем кубики и число оставшихся ходов локально */
  const diceLeft = [...longDiceValues];
  diceLeft.splice(diceLeft.indexOf(dieVal), 1);            // убираем использованный кубик
  setLongDiceValues(diceLeft);
  setLongNumberMove(n => n - 1);



    const totalOff = longMyColor === 'white'
  ? nextWhiteOff.length
  : nextBlackOff.length;


if (totalOff === 15) {
  longConfirmMove({
    boardStateOverride: nextBoard,
    whiteOffOverride: nextWhiteOff,
    blackOffOverride: nextBlackOff
  });
  return;
}

  /* 6.  Отправляем на сервер ***те же самые*** nextWhiteOff / nextBlackOff */
  longSocket.emit('longGame_updateBoardState', {
    longTableId       : parseInt(tableId, 10),
    boardState        : nextBoard,
    longWhiteOffBoard : nextWhiteOff,                      // ✅ уже обновлённый массив
    longBlackOffBoard : nextBlackOff,                      // ✅ уже обновлённый массив
    longNumberMove    : longNumberMove - 1
  });
};





const undoLastMove = () => {
  if (longMoveHistory.length === 0) {
    
    return;
  }

  const last = longMoveHistory[longMoveHistory.length - 1];

  /* --- общее восстановление доски/кубиков/счётчиков ---------- */
  setLongBoardState(deepCopyBoard(last.boardBefore));
  setLongDiceValues([...last.prevDiceValues]);
  setLongNumberMove(last.prevNumberMove);

  /* --- если это был bear-off – откатить и off-board ----------- */
  if (last.type === 'bearOff') {
    setLongWhiteOffBoard(last.prevWhiteOffBoard);
    setLongBlackOffBoard(last.prevBlackOffBoard);
    // console.log('[Undo] Вернули шашку из off-board на пункт',
    //             indexToVisualNumber(last.from));
  } else {
    /* ход с головы? – корректируем счётчик */
    if ((longMyColor === 'white' && last.from === 23) ||
        (longMyColor === 'black' && last.from === 11)) {
      setHeadMoveCount(prev => Math.max(prev - 1, 0));
      setHeadCheckersMoved(prev => Math.max(prev - 1, 0)); 
    }
  }

  /* --- чистим историю и отправляем событие ------------------- */
  setLongMoveHistory(prev => prev.slice(0, -1));

  longSocket.emit('longGame_undoMove', {
    longTableId      : parseInt(tableId, 10),
    newBoardState    : last.boardBefore,
    longWhiteOffBoard: last.type === 'bearOff'
                         ? last.prevWhiteOffBoard
                         : longWhiteOffBoard,
    longBlackOffBoard: last.type === 'bearOff'
                         ? last.prevBlackOffBoard
                         : longBlackOffBoard,
    longNumberMove   : last.prevNumberMove
  });
};




function allInHome(board, colour) {
  const [lo, hi] = colour === 'white' ? [0, 5] : [12, 17];
  for (let i = 0; i < 24; i++) {
    if (board[i].length && board[i][0].color === colour) {
      if (i < lo || i > hi) return false;
    }
  }
  return true;
}


function canBearOff(board, colour, pointIdx, die) {
  if (!allInHome(board, colour)) return false;       // ещё не все дома

  if (colour === 'white') {
    // точное/overshoot правило для белых
    if (pointIdx === die - 1) return true;
    if (pointIdx < die - 1) {
      for (let i = pointIdx + 1; i <= 5; i++) {
        if (board[i].length && board[i][0].color === 'white') return false;
      }
      return true;
    }
//   } else { // black
//    const target = 12 + die - 1;            // пункт, который «закрывает» кубик
//   if (pointIdx === target) return true;   // точный бросок

//   /* overshoot: кубик больше, чем нужно */
//   if (pointIdx < target) {
//     for (let i = pointIdx + 1; i <= target; i++) {
//       if (board[i].length && board[i][0].color === 'black') return false;
//     }
//     return true;                          // «перебор» разрешён
//   }
// }
} else {                     // ---------- ЧЁРНЫЕ ----------
  /* 0.  Вычисляем позицию шашки в маршруте */
  const posInPath = blackLongPath.findIndex(p => p - 1 === pointIdx);
  if (posInPath === -1) return false;           // не нашли — ошибка данных

  const distance = blackLongPath.length - posInPath;  // точный кубик

  /* 1) ТОЧНЫЙ бросок */
  if (die === distance) return true;

  /* 2) «Перебор» разрешён ТОЛЬКО если ПЕРЕД шашкой (с точки posInPath‑1
        и дальше к выходу) нет ни одной своей шашки */
  if (die > distance) {
    for (let i = 0; i < posInPath; i++) {       // всё, что «дальше выхода»
      const idx = blackLongPath[i] - 1;         // board‑index
      if (board[idx].length && board[idx][0].color === 'black') {
        return false;                           // есть дальняя шашка
      }
    }
    return true;                                // перебор допустим
  }

  /* 3) die < distance  →  обычный ход, не bear‑off */
  return false;
}

  return false;
}
 
  const longConfirmMove = useCallback((
  {
    boardStateOverride,
    whiteOffOverride,
    blackOffOverride
  } = {}
) => {
    if (isSpectator) return;
    
    if (!tableId) {
      console.error('tableId не определен');
      return;
    }
  
    if (!longCurrentTurn) {
      console.error('currentTurn не определен');
      return;
    }
  
    const boardStateString = JSON.stringify(longBoardState); 
  
    if (!boardStateString) {
      console.error('longBoard is undefined or empty');
      return;
    }

    setLongMoveHistory([]); 
    justConfirmedRef.current = true;

  // [FIX 2.1] — сразу блокируем клики, чтобы не было двойных действий:
  setLongDisableBoardClicks(true);

  // [FIX 2.2] — локально скрываем кнопку "Бросить кубики"
  setLongRollEnabled(false);





 
    // После отправки хода обновляем локальное состояние
    const nextTurn = longCurrentTurn === 'player1' ? 'player2' : 'player1';
    setLongCurrentTurn(nextTurn);
    setLongFirstRollComplete(true);
    setLongFirstMoveComplete(true);
    khachapuriOpeningRef.current.active = false;
    // setTournamentHasRolledDice(true); 
    setLongUsedRolls([]); // Сбрасываем использованные значения кубиков
    setLongRolledDice([]); // Сбрасываем использованные значения кубиков
    setLongFirstRolls(null);
    
    setLongHasRolledDice(true)
    // console.log('[Tournament] Ход завершен, передан на сервер.');


 
    // Хачапури: отправляем confirm СРАЗУ.
    // Старые 700 мс задержки визуально выглядели как несработавшая кнопка
    // и провоцировали повторные нажатия на телефоне.
    longSocket.emit('long_confirmMove', {
      tableId: tableId,
      player: longCurrentTurn,
      longBoardState: boardStateOverride ?? longBoardState,
      longWhiteOffBoard: whiteOffOverride ?? longWhiteOffBoard,
      longBlackOffBoard: blackOffOverride ?? longBlackOffBoard,
    });

  

  }, [
    tableId,
    longCurrentTurn,
    longBoardState,
    longWhiteOffBoard,
    longBlackOffBoard
  ]);


const proposeDouble = () => {
  if (!canDouble) return; // блокируем клик, если нельзя удвоить

  longSocket.emit('long_proposeDouble', {
    tableId: parseInt(tableId, 10),
    player: username,
  });

  setWaitingDoubleReply(true);
};



const respondToDouble = (accepted) => {
  if (!doubleProposal) return;
// longSocket.emit('registerUser', { userName: username });
  longSocket.emit('long_respondDouble', {
    tableId : tableId,
    accepted
  });

  /* разблокируем доску и убираем окно */
  setWaitingDoubleReply(true);
  
  setDoubleProposal(null);
  
};



useEffect(() => {
 function handleDoubleAccepted({ multiplier, cubeOwner, by, newTurn }) {
  setBetMultiplier(multiplier);
  setCubeOwner(cubeOwner);
  setLastDoubler(by);

  setWaitingDoubleReply(false); // больше не ждём ответа

  // если ЭТО МЫ нажали «TAKE» – прячем «ОК» до следующего броска
  if (by !== username) setDoubleJustTaken(true);

  // setLongHasRolledDice(false);  // ждём нового броска
  const myRole = (longMyColor === 'white') ? 'player1' : 'player2';
  setLongDisableBoardClicks(myRole !== newTurn);
  setLongCurrentTurn(newTurn);
  setLongNumberMove(0);
}

  longSocket.on('long_doubleAccepted', handleDoubleAccepted);
  return () => longSocket.off('long_doubleAccepted', handleDoubleAccepted);
}, []);



  useEffect(() => {
  function handleBoardUpdated(p) {
    if (String(p.longTableId) !== String(tableId)) return;
    // if (p.whiteOffBoard) setLongWhiteOffBoard(p.whiteOffBoard);
    // if (p.blackOffBoard) setLongBlackOffBoard(p.blackOffBoard);
    if (p.longWhiteOffBoard !== undefined) {
   setLongWhiteOffBoard(p.longWhiteOffBoard);
 } else if (p.whiteOffBoard !== undefined) {
   setLongWhiteOffBoard(p.whiteOffBoard);
 }

 if (p.longBlackOffBoard !== undefined) {
   setLongBlackOffBoard(p.longBlackOffBoard);
 } else if (p.blackOffBoard !== undefined) {
   setLongBlackOffBoard(p.blackOffBoard);
 }

    if (p.boardState)    setLongBoardState(p.boardState);
    if (typeof p.longNumberMove === 'number')
         setLongNumberMove(p.longNumberMove);
  }
  longSocket.on('longGame_boardUpdated', handleBoardUpdated);
  return () => longSocket.off('longGame_boardUpdated', handleBoardUpdated);
}, [tableId]);







useEffect(() => {
  /** приходит после confirmMove */
  const handleConfirmed = (data) => {
    if (String(data.tableId) !== String(tableId)) return;

    /* --- обновляем позицию для ВСЕХ --- */
    setLongBoardState( safeParseBoard(data.longBoardState) );
    /* имя поля может быть whiteOffBoard или longWhiteOffBoard */
    setLongWhiteOffBoard(data.longWhiteOffBoard ?? data.whiteOffBoard ?? []);
    setLongBlackOffBoard(data.longBlackOffBoard ?? data.blackOffBoard ?? []);
    setLongCurrentTurn(data.newCurrentTurn);
    setLongNumberMove(data.numberMove || 0);
    setLongFirstMoveComplete(true);
    khachapuriOpeningRef.current.active = false;
    /* ---- дальше — только для участника партии ---- */
    if (isSpectator) return;

    setLongHasRolledDice(false);
    setLongFirstRolls(null);
    setLongRolledDice([]);
    /* остальной «игровой» код, который уже был у вас */
  };

  longSocket.on('long_confirmed', handleConfirmed);
  return () => longSocket.off('long_confirmed', handleConfirmed);
}, [tableId, isSpectator, longMyColor]);


  
function normalizeRolls(raw) {
  let value = raw;

  // После F5 TEXT-поля Sequelize приходят как JSON-строки.
  if (typeof value === 'string') {
    try {
      value = JSON.parse(value);
    } catch (e) {
      return [];
    }
  }

  if (!Array.isArray(value)) return [];

  const normalized = Array.isArray(value[0])
    ? value
    : (value.length === 2 ? [value] : []);

  // Не пропускаем undefined/NaN в расчёт доступных ходов.
  return normalized
    .map((pair) => Array.isArray(pair) ? pair.map(Number) : [])
    .filter((pair) =>
      pair.length >= 2 &&
      Number.isInteger(pair[0]) && pair[0] >= 1 && pair[0] <= 6 &&
      Number.isInteger(pair[1]) && pair[1] >= 1 && pair[1] <= 6
    );
}

function diceArrayFromRoll(roll) {
  if (!Array.isArray(roll) || roll.length < 2) return [];

  const d1 = Number(roll[0]);
  const d2 = Number(roll[1]);

  if (
    !Number.isInteger(d1) || d1 < 1 || d1 > 6 ||
    !Number.isInteger(d2) || d2 < 1 || d2 > 6
  ) {
    return [];
  }

  return d1 === d2 ? [d1, d1, d1, d1] : [d1, d2];
}












useEffect(() => {

  function handleRoundReset(payload) {
    khachapuriOpeningRef.current.active = false;
    // 1) убеждаемся, что событие относится к нашему столу
    if (String(payload.tableId) !== String(tableId)) return;

    /* 2. доска и off‑board */
    setLongBoardState( safeParseBoard(payload.board_state) );
    setLongWhiteOffBoard(payload.white_off_board);
    setLongBlackOffBoard(payload.black_off_board);

    /* 3. таймеры */
     if (Number.isFinite(payload.player1_time_left))
     setLongPlayer1Time(payload.player1_time_left);

     if (Number.isFinite(payload.player2_time_left))
     setLongPlayer2Time(payload.player2_time_left);


    /* 4. счёт матча / номер партии */
    setMatchScore(payload.score);
    setTargetPoints(payload.targetPoints);

    if (payload.round_number != null) {
      const n = Number(payload.round_number);
      if (Number.isFinite(n) && n > 0) setCurrentGameNumber(Math.floor(n));
    } else if (payload.rounds_completed != null) {
      const completed = Number(payload.rounds_completed);
      if (Number.isFinite(completed) && completed >= 0) {
        setCurrentGameNumber(Math.floor(completed) + 1);
      }
    }

    setCubeOwner(
       payload.cube_owner !== undefined ? payload.cube_owner : null
     );
     setBetMultiplier(
       payload.bet_multiplier !== undefined ? payload.bet_multiplier : 1
     );
     setLastDoubler(null);
    /* 5. локальные флаги/кубики — всё обнуляем */
    setLongDiceValues([]);
    setLongRolledDice([]);
    setLongNumberMove(0);
    setLongHasRolledDice(false);
    setLongRollEnabled(false);
    setLongDisableBoardClicks(true); // ждём autoLongFirstRoll
    if (payload.is_crawford !== undefined) {
     setIsCrawfordGame(!!payload.is_crawford);
     }  // 👈 сохраняем флаг
    setLongCurrentTurn(null);
    headInitialCountRef.current = null; // «голова» со следующего раунда считаем заново

    setLongMoveHistory([]);          // ← очищаем историю ходов
    setLongShowUndoButton(false);    // ← явно прячем кнопку
    setLongLastMoveType(null);       // ← на всякий случай
    setHeadMoveCount(0);
    setHeadCheckersMoved(0);
      /*  ➤➤  сбрасываем все «зависшие» флаги удвоения  */
  setWaitingDoubleReply(false);
  setDoubleProposal(null);
  setDoubleJustTaken(false);

  }

  longSocket.on('long_roundReset', handleRoundReset);
  return () => longSocket.off('long_roundReset', handleRoundReset);
}, [tableId]);






useEffect(() => {
  function handleTournamentDataResponse(data) {
    if (!data) return;

    if (
      khachapuriOpeningRef.current.active &&
      !Boolean(data.firstRollComplete) &&
      !Boolean(data.firstMoveComplete)
    ) {
      console.log('[KHACHAPURI] stale pre-start longDataResponse ignored', {
        tableId: data.khachapuri_table_id || data.long_table_id,
      });
      return;
    }

    // 1. Распознаём броски игроков
    const parsedPlayer1Rolls = normalizeRolls(data.player1_rolls);
    const parsedPlayer2Rolls = normalizeRolls(data.player2_rolls);
    const lastRollP1 = parsedPlayer1Rolls.at(-1) || [];
    const lastRollP2 = parsedPlayer2Rolls.at(-1) || [];

    // 2. Определяем цвет
    const myUsername = localStorage.getItem("username") || "";

    let myColor = '';
    let iAmWhite = false;

    if (isSpectator) {
      // 🟡 Наблюдатель: цвет текущего игрока для кубиков
      setLongMyColor(null);
      setLongPlayerColor(null);
      setLongOpponentColor(null);

      const isWhiteTurn = data.current_turn === 'player1';
      const currentRoll = isWhiteTurn ? lastRollP1 : lastRollP2;
      const diceColor = isWhiteTurn ? 'white' : 'black';

      setRolledByPlayer(isWhiteTurn ? 'player1' : 'player2');
      setLongRolledDice(currentRoll);

      const [d1, d2] = currentRoll;
      if (d1 && d2) {
        const isDouble = d1 === d2;
        const diceArray = isDouble ? [d1, d1, d1, d1] : [d1, d2];
        setLongDiceValues(diceArray);
      } else {
        setLongDiceValues([]);
      }

      setDiceColorForRender(diceColor); // ✅ цвет кубиков для спектатора
    } else {
      // 🟢 Игрок
      myColor = (data.player1_name === myUsername) ? 'white' : 'black';
      iAmWhite = myColor === 'white';

      setLongPlayerColor(myColor);
      setLongMyColor(myColor);
      setLongOpponentColor(iAmWhite ? 'black' : 'white');
    }

    // 3. Парсим доску
    const parsedBoard = safeParseBoard(data.board_state);
    setLongBoardState(parsedBoard);

    // 4. off_board
    setLongWhiteOffBoard(Array.isArray(data.white_off_board) ? data.white_off_board : []);
    setLongBlackOffBoard(Array.isArray(data.black_off_board) ? data.black_off_board : []);

    // 5. Таймеры
    setLongPlayer1Time(
      Number.isFinite(data.player1_time_left) ? data.player1_time_left : 300
    );
    setLongPlayer2Time(
      Number.isFinite(data.player2_time_left) ? data.player2_time_left : 300
    );

    // 6. Счёт / количество партий / текущая партия
    if (Array.isArray(data.score)) setMatchScore([+data.score[0], +data.score[1]]);
    if (data.targetPoints != null) setTargetPoints(+data.targetPoints);

    if (data.round_number != null) {
      const n = Number(data.round_number);
      if (Number.isFinite(n) && n > 0) setCurrentGameNumber(Math.floor(n));
    } else if (data.rounds_completed != null) {
      const completed = Number(data.rounds_completed);
      if (Number.isFinite(completed) && completed >= 0) {
        setCurrentGameNumber(Math.floor(completed) + 1);
      }
    }

    if (typeof data.is_crawford === 'boolean') setIsCrawfordGame(!!data.is_crawford);

    /* ------------  КУБ  ------------ */
    setCubeOwner(data.cube_owner || null);
    setBetMultiplier(data.bet_multiplier || 1);
    setMaxBet(Number(data.max_bet) || 0);
    setInitialBet(Number(data.initial_bet) || 1);

    if (data.is_crawford !== undefined) {
      setIsCrawfordGame(!!data.is_crawford);
    }

    // 7. Текущий ход
    const currentTurn = data.current_turn || null;
    setLongCurrentTurn(currentTurn);

    // 8. Имена / аватары
    setLongPlayer1Name(data.player1_name || '');
    setLongPlayer2Name(data.player2_name || '');

    setLongPlayer1Avatar(
      normUrl(
        data.player1_avatar ||
        data.player1Avatar ||
        data.player1_avatar_url ||
        ''
      )
    );
    setLongPlayer2Avatar(
      normUrl(
        data.player2_avatar ||
        data.player2Avatar ||
        data.player2_avatar_url ||
        ''
      )
    );

    /*
     * ХАЧАПУРИ opening state.
     * Основной источник — khachapuri_opening_*.
     * Fallback — firstRollComplete/current_turn + rolls стартующего.
     */
    const openingFlag =
      Boolean(data.khachapuri_opening_active) ||
      (
        Boolean(data.firstRollComplete) &&
        !Boolean(data.firstMoveComplete)
      );

    if (openingFlag) {
      const starter =
        data.khachapuri_round_starter === 'player2' ||
        data.current_turn === 'player2'
          ? 'player2'
          : 'player1';

      const dedicatedDice = Array.isArray(data.khachapuri_opening_dice)
        ? data.khachapuri_opening_dice.map(Number).slice(0, 2)
        : [];

      const starterRoll =
        starter === 'player1'
          ? (parsedPlayer1Rolls.at(-1) || [])
          : (parsedPlayer2Rolls.at(-1) || []);

      const openingDice =
        dedicatedDice.length >= 2
          ? dedicatedDice
          : starterRoll.map(Number).slice(0, 2);

      if (
        openingDice.length >= 2 &&
        Number.isInteger(openingDice[0]) &&
        openingDice[0] >= 1 &&
        openingDice[0] <= 6 &&
        Number.isInteger(openingDice[1]) &&
        openingDice[1] >= 1 &&
        openingDice[1] <= 6
      ) {
        khachapuriRoundStartHandlerRef.current?.({
          tableId: Number(
            data.khachapuri_table_id ||
            data.long_table_id ||
            longTableId
          ),
          round: Number(data.round_number || 1),
          starter,
          dice: openingDice,
          numberMove: Number(
            data.khachapuri_opening_number_move ||
            (openingDice[0] === openingDice[1] ? 4 : 2)
          ),
          player1_name: data.player1_name || '',
          player2_name: data.player2_name || '',
          replay: true,
        });

        setLongLoading(false);
        return;
      }
    }

    // 9. Флаги броска кубиков
    const hasRolledAlready = iAmWhite
      ? data.hasRolledDicePlayer1
      : data.hasRolledDicePlayer2;

    const opponentHasRolled = iAmWhite
      ? data.hasRolledDicePlayer2
      : data.hasRolledDicePlayer1;

    setLongHasRolledDice(hasRolledAlready);

    // 10. numberMove с сервера
    // const movesLeftServer = iAmWhite
    //   ? (data.numberMovePlayer1 ?? 0)
    //   : (data.numberMovePlayer2 ?? 0);
let movesLeftServer = iAmWhite
  ? data.numberMovePlayer1
  : data.numberMovePlayer2;

// Если сервер не прислал — НЕ затираем на 0
if (movesLeftServer === undefined || movesLeftServer === null) {
  movesLeftServer = longNumberMove; // ← сохраняем прежнее значение
}

    // 11. Мой ли сейчас ход?
    const itsMyTurn =
      (iAmWhite && currentTurn === 'player1') ||
      (!iAmWhite && currentTurn === 'player2');

    // 12. Показ кубиков и lastRoll
    if (itsMyTurn) {
      if (hasRolledAlready) {
        const myLastRoll = iAmWhite ? lastRollP1 : lastRollP2;
        setLongRolledDice(myLastRoll);

        const diceArray = diceArrayFromRoll(myLastRoll);
        setLongDiceValues(diceArray);
      } else {
        setLongRolledDice([]);
        setLongDiceValues([]);
      }
    } else {
      if (opponentHasRolled) {
        const oppLastRoll = iAmWhite ? lastRollP2 : lastRollP1;
        setLongRolledDice(oppLastRoll);
      } else {
        setLongRolledDice([]);
      }
    }

    // 13. Кнопка "Бросить кубики"
    setLongRollEnabled(itsMyTurn && !hasRolledAlready);

    // Dedicated opening Хачапури обработан выше.
    setLongFirstRolls(null);
    setLongFirstMoveComplete(!!data.firstMoveComplete);
    setLongFirstRollComplete(!!data.firstRollComplete);

    if (data.firstMoveComplete) {
      khachapuriOpeningRef.current.active = false;
    }

    // === ВОССТАНОВЛЕНИЕ numberMove ПОСЛЕ ОБНОВЛЕНИЯ СТРАНИЦЫ ===
    //
    // 1) по умолчанию берём то, что пришло с сервера
    // 2) если это НЕ зритель, мой ход и я уже кидал кубики —
    //    пересчитываем количество реально доступных ходов по доске и кубикам

    let movesLeft = movesLeftServer;

    if (!isSpectator && hasRolledAlready && itsMyTurn) {
      const myLastRoll = iAmWhite ? lastRollP1 : lastRollP2;

      if (Array.isArray(myLastRoll) && myLastRoll.length >= 2) {
        const diceArray = diceArrayFromRoll(myLastRoll);

        // ⬇️ пересчитываем доступные ходы только если бросок валидный
        if (diceArray.length > 0) {
          movesLeft = calculateUsableDice(parsedBoard, myColor, diceArray);
        }
      }
    }

    setLongNumberMove(movesLeft);
    setLongHasRolledDice(hasRolledAlready);

    // На всякий случай ещё раз выставляем кубики, если уже бросали
    if (hasRolledAlready && !isSpectator) {
      const roll = iAmWhite ? lastRollP1 : lastRollP2;
      setLongDiceValues(diceArrayFromRoll(roll));
    }

// === ВАЖНО: ВОССТАНОВЛЕНИЕ ХОДОВ ПОСЛЕ ОБНОВЛЕНИЯ СТРАНИЦЫ ===

if (!isSpectator && itsMyTurn) {

  if (hasRolledAlready) {
    const myLastRoll = iAmWhite ? lastRollP1 : lastRollP2;

    // 1. восстанавливаем diceValues
    const diceArray = diceArrayFromRoll(myLastRoll);
    setLongDiceValues(diceArray);

    // 2. пересчитываем numberMove только для валидного броска.
    // Если сервер ещё не прислал пару кубиков — сохраняем server-side numberMove.
    const usableMoves = diceArray.length > 0
      ? calculateUsableDice(parsedBoard, myColor, diceArray)
      : movesLeftServer;

    // setLongNumberMove(usableMoves);
if (Number.isFinite(usableMoves)) {
  setLongNumberMove(usableMoves);
}

    // 3. если usableMoves > 0 — скрыть кнопку ОК
    if (usableMoves > 0) {
      setLongHasRolledDice(true);
      setLongRollEnabled(false); // уже бросил
    } else {
      // ходы невозможны → показываем ОК
      setLongHasRolledDice(true);
      setLongRollEnabled(false);
    }
  } else {
    // кубики не кидал → ОК не должен гореть
    setLongHasRolledDice(false);
    setLongDiceValues([]);
    setLongRolledDice([]);
    setLongRollEnabled(true);
  }
}

    
    setLongLoading(false);
  }

  // ✅ ПОДПИСКА НА ОТВЕТ СЕРВЕРА
  longSocket.on("longDataResponse", handleTournamentDataResponse);

  // ✅ ОТПИСКА ПРИ АНМАУНТЕ / СМЕНЕ longTableId
  return () => {
    longSocket.off("longDataResponse", handleTournamentDataResponse);
  };
}, [longTableId, isSpectator, normUrl]);



//   useEffect(() => {

    
//     // function longFetchData() {
//     //   if (longSocket.connected) {
      
        
//     //     longSocket.emit("longFetchData", tableId);
//     //   } else {
//     //     const handleConnect = () => {
//     //       longSocket.emit("longFetchData", tableId);
//     //     };
//     //     longSocket.on("connect", handleConnect);
//     //     return () => {
//     //       longSocket.off("connect", handleConnect);
//     //     };
//     //   } 
//     // }
//    function handleTournamentDataResponse(data) {
//   if (!data) return;

//   // 1. Распознаём броски игроков
//   const parsedPlayer1Rolls = normalizeRolls(data.player1_rolls);
//   const parsedPlayer2Rolls = normalizeRolls(data.player2_rolls);
//   const lastRollP1 = parsedPlayer1Rolls.at(-1) || [];
//   const lastRollP2 = parsedPlayer2Rolls.at(-1) || [];

//   // 2. Определяем цвет
//   const myUsername = localStorage.getItem("username") || "";

//   let myColor = '';
//   let iAmWhite = false;

//   if (isSpectator) {
//     // 🟡 Наблюдатель: цвет текущего игрока для кубиков
//     setLongMyColor(null);
//     setLongPlayerColor(null);
//     setLongOpponentColor(null);

//     const isWhiteTurn = data.current_turn === 'player1';
//     const currentRoll = isWhiteTurn ? lastRollP1 : lastRollP2;
//     const diceColor = isWhiteTurn ? 'white' : 'black';
//     setRolledByPlayer(isWhiteTurn ? 'player1' : 'player2');
//     setLongRolledDice(currentRoll);
//     const [d1, d2] = currentRoll;
//     const isDouble = d1 === d2;
//     const diceArray = isDouble ? [d1, d1, d1, d1] : [d1, d2];
//     setLongDiceValues(diceArray);

//     setDiceColorForRender(diceColor); // ✅ Устанавливаем цвет для отображения
//   } else {
//     // 🟢 Игрок
//     myColor = (data.player1_name === myUsername) ? 'white' : 'black';
//     iAmWhite = myColor === 'white';
//     setLongPlayerColor(myColor);
//     setLongMyColor(myColor);
//     setLongOpponentColor(iAmWhite ? 'black' : 'white');
//   }
//   // 2. Парсим доску через safeParseBoard
//   const parsedBoard = safeParseBoard(data.board_state);
//   setLongBoardState(parsedBoard);

//   // 3. off_board
//   setLongWhiteOffBoard(Array.isArray(data.white_off_board) ? data.white_off_board : []);
//   setLongBlackOffBoard(Array.isArray(data.black_off_board) ? data.black_off_board : []);

//   //  ⏱  начальные времена
//   setLongPlayer1Time(Number.isFinite(data.player1_time_left) ? data.player1_time_left : 300);
//   setLongPlayer2Time(Number.isFinite(data.player2_time_left) ? data.player2_time_left : 300);


//   // ... после разбора board/off/таймеров
// if (Array.isArray(data.score)) setMatchScore([+data.score[0], +data.score[1]]);
// if (data.targetPoints != null) setTargetPoints(+data.targetPoints);
// if (typeof data.is_crawford === 'boolean') setIsCrawfordGame(!!data.is_crawford);


//   /* ------------  КУБ  ------------ */
//   setCubeOwner(data.cube_owner || null);
//   setBetMultiplier(data.bet_multiplier || 1);
//   // setMaxBet(data.max_bet || 0);
//   // setInitialBet(data.initial_bet || 1);
  
//   setMaxBet(Number(data.max_bet) || 0);
//  setInitialBet(Number(data.initial_bet) || 1);
  
  
//   if (data.is_crawford !== undefined) {
//    setIsCrawfordGame(!!data.is_crawford);
//  }
//   // 4. Текущий ход
//   const currentTurn = data.current_turn || null;
//   setLongCurrentTurn(currentTurn);

//   // 5. Имена
//   setLongPlayer1Name(data.player1_name || '');
//   setLongPlayer2Name(data.player2_name || '');

//   setLongPlayer1Avatar(normUrl(
//     data.player1_avatar || data.player1Avatar || data.player1_avatar_url || ''
//   ));
//   setLongPlayer2Avatar(normUrl(
//     data.player2_avatar || data.player2Avatar || data.player2_avatar_url || ''
//   ));

//   // 6. Флаги броска кубиков
//   const hasRolledAlready = iAmWhite
//     ? data.hasRolledDicePlayer1
//     : data.hasRolledDicePlayer2;
//   const opponentHasRolled = iAmWhite
//     ? data.hasRolledDicePlayer2
//     : data.hasRolledDicePlayer1;
//   setLongHasRolledDice(hasRolledAlready);

//   // 7. Распознаём броски игроков
 



//   // 8. NumberMove (из сервера)
//   const movesLeftServer = iAmWhite
//     ? (data.numberMovePlayer1 ?? 0)
//     : (data.numberMovePlayer2 ?? 0);

//   // setLongNumberMove(movesLeftServer);

//   // 9. Показываем кубики и diceValues
//   const itsMyTurn = (
//     (iAmWhite && currentTurn === 'player1') ||
//     (!iAmWhite && currentTurn === 'player2')
//   );

//   if (itsMyTurn) {
//     if (hasRolledAlready) {
//       const myLastRoll = iAmWhite ? lastRollP1 : lastRollP2;
//       setLongRolledDice(myLastRoll);

//       const [d1, d2] = myLastRoll;
//       const isDouble = d1 === d2;
//       const diceArray = isDouble ? [d1, d1, d1, d1] : [d1, d2];

//       setLongDiceValues(diceArray);
//     } else {
//       setLongRolledDice([]);
//       setLongDiceValues([]);
//     }
//   } else {
//     if (opponentHasRolled) {
//       const oppLastRoll = iAmWhite ? lastRollP2 : lastRollP1;
//       setLongRolledDice(oppLastRoll);
//     } else {
//       setLongRolledDice([]);
//     }
//   }

//   // 10. Кнопка "Бросить кубики"
//   setLongRollEnabled(itsMyTurn && !hasRolledAlready);

//   // 11. Первый бросок (авто)
//   if (data.firstRollComplete && !data.firstMoveComplete) {
//     const currentPlayer = data.current_turn;
//     const last = currentPlayer === 'player1'
//       ? parsedPlayer1Rolls.at(-1) || []
//       : parsedPlayer2Rolls.at(-1) || [];

//     setLongFirstRolls({
//       player1Roll: last[0] ?? null,
//       player2Roll: last[1] ?? null,
      
//     });
//     setLongRolledDice([last[0], last[1]]);
//   } else {
//     setLongFirstRolls(null);
//   }

//   setLongFirstMoveComplete(data.firstMoveComplete || false);
//   setLongFirstRollComplete(data.firstMoveComplete || false);


//   // === ВОССТАНОВЛЕНИЕ numberMove ПОСЛЕ ОБНОВЛЕНИЯ СТРАНИЦЫ ===

// // const movesLeft = iAmWhite
// //   ? (data.numberMovePlayer1 ?? 0)
// //   : (data.numberMovePlayer2 ?? 0);

// // setLongNumberMove(movesLeft);
// // setLongHasRolledDice(hasRolledAlready);

// // if (hasRolledAlready) {
// //     const roll = iAmWhite ? lastRollP1 : lastRollP2;
// //     const [d1, d2] = roll;
// //     const isDouble = d1 === d2;
// //     setLongDiceValues(isDouble ? [d1, d1, d1, d1] : [d1, d2]);
// // }

// //   setLongLoading(false);
// // }
//   // === ВОССТАНОВЛЕНИЕ numberMove ПОСЛЕ ОБНОВЛЕНИЯ СТРАНИЦЫ ===
//   //
//   // 1) по умолчанию берём то, что пришло с сервера
//   // 2) если это НЕ зритель, мой ход и я уже кидал кубики —
//   //    пересчитываем количество реально доступных ходов по доске и кубикам

//   let movesLeft = iAmWhite
//     ? (data.numberMovePlayer1 ?? 0)
//     : (data.numberMovePlayer2 ?? 0);

//   if (!isSpectator && hasRolledAlready && itsMyTurn) {
//     const myLastRoll = iAmWhite ? lastRollP1 : lastRollP2;

//     if (Array.isArray(myLastRoll) && myLastRoll.length >= 2) {
//       const [d1, d2] = myLastRoll;
//       const isDouble = d1 === d2;
//       const diceArray = isDouble ? [d1, d1, d1, d1] : [d1, d2];

//       // ⬇️ вот здесь уже используем твою calculateUsableDice
//       movesLeft = calculateUsableDice(parsedBoard, myColor, diceArray);
//     }
//   }

//   setLongNumberMove(movesLeft);
//   setLongHasRolledDice(hasRolledAlready);

//   if (hasRolledAlready) {
//     const roll = iAmWhite ? lastRollP1 : lastRollP2;
//     const [d1, d2] = roll;
//     const isDouble = d1 === d2;
//     setLongDiceValues(isDouble ? [d1, d1, d1, d1] : [d1, d2]);
//   }

//   setLongLoading(false);
// }


    
//     // Вызовем fetchTournamentData при монтировании
//     // longFetchData();
//     // longSocket.on("longDataResponse", handleTournamentDataResponse);
  
//     return () => {
//       longSocket.off("longDataResponse", handleTournamentDataResponse);
//     };
//   }, [longTableId]); 




useEffect(() => {
  const handleTimer = ({ player1_time_left, player2_time_left, currentTurn }) => {
    console.log('[KHACHAPURI][TIMER][CLIENT]', {
      player1_time_left,
      player2_time_left,
      currentTurn,
    });

    setLongPlayer1Time(player1_time_left);
    setLongPlayer2Time(player2_time_left);
    setLongCurrentTurn(currentTurn); // держим актуальный ход
  };

  longSocket.on('timerStarted', handleTimer);
  return () => {
    longSocket.off('timerStarted', handleTimer);
  };
}, []);

  













useEffect(() => {
  const id = setInterval(() => {
    setLongPlayer1Time((t) => longCurrentTurn === 'player1' ? Math.max(t - 1, 0) : t);
    setLongPlayer2Time((t) => longCurrentTurn === 'player2' ? Math.max(t - 1, 0) : t);
  }, 1000);

  return () => clearInterval(id);
}, [longCurrentTurn]);




// 🔁 ПОСЛЕ РЕКОННЕКТА ЗАПРАШИВАЕМ ПОЛНЫЙ СНАП С СЕРВЕРА
// useEffect(() => {
//   if (!tableId) return;

//   const handleLongConn = (e) => {
//     const detail = e.detail || {};

//     // нас интересует именно восстановление после обрыва
//     if (detail.state !== 'online' || !detail.recovered) return;

//     if (longSocket.connected) {
//       console.log('[Long] reconnect → longFetchData для стола', tableId);
//       longSocket.emit('longFetchData', tableId);
//     }
//   };

//   window.addEventListener('long-conn', handleLongConn);
//   return () => window.removeEventListener('long-conn', handleLongConn);
// }, [tableId]);


  function calculateRealMoves(board, playerColor, diceArray) {
    let legalMovesCount = 0;
    console.log("[DEBUG] calculateRealMoves - запуск проверки допустимых ходов");
    
    for (let from = 0; from < board.length; from++) {
      // Проверяем, что в данной точке есть шашки нужного цвета.
      if (board[from].length > 0 && board[from][0].color === playerColor) {
      
        for (let die of diceArray) {
          // Для белых ход идёт по уменьшению индекса, для чёрных – по увеличению.
          let target = playerColor === 'white' ? from - die : from + die;
       
          
          // Если целевой индекс выходит за границы доски – ход невозможен.
          if (target < 0 || target >= board.length) {
          
            continue;
          }
          
          const targetPoint = board[target];
          if (!targetPoint || targetPoint.length === 0) {
          
            legalMovesCount++;
          } else if (targetPoint.every(ch => ch.color === playerColor)) {
          
            legalMovesCount++;
          } else {
           
          }
        }
      }
    }
    
   
    return legalMovesCount;
  }
  
  



// const onSurrenderClick = () => {
//   const confirm = window.confirm('Вы уверены, что хотите сдаться?');
//   if (!confirm) return;

//   longSocket.emit('long_surrender', { tableId: parseInt(tableId, 10) });
// };

const onSurrenderClick = () => {
  setShowSurrenderModal(true); // просто открываем модалку подтверждения
};
const handleConfirmSurrender = () => {
  longSocket.emit('long_surrender', { tableId: parseInt(tableId, 10) });
  setShowSurrenderModal(false);
};
const handleCancelSurrender = () => setShowSurrenderModal(false);




  function allCheckersInHome(board, playerColor) {
    if (playerColor === 'white') {
      // Проверяем, что ни одна белая шашка не находится вне зон 1-6 (индексы 0-5)
      for (let i = 0; i < board.length; i++) {
        if (board[i] && board[i].length > 0) {
          for (let checker of board[i]) {
            if (checker.color === 'white' && (i < 0 || i > 5)) {
              return false;
            }
          }
        }
      }
    } else {
      // Для чёрных разрешён вывод только если все шашки находятся в зоне 19-24 (индексы 18-23)
      for (let i = 0; i < board.length; i++) {
        if (board[i] && board[i].length > 0) {
          for (let checker of board[i]) {
          if (checker.color === 'black' && (i < 12 || i > 17)) {
              return false;
            }
          }
        }
      }
    }
    return true;
  }
  






/**
 * Проверяет, не образуется ли «прайм» (6+ подряд) для игрока `playerColor`
 * с учётом того, что мы обрезаем маршрут на «самой последней (ближайшей к дому соперника)» шашке врага.
 *
 * @param {Array<Array<{color:string}>>} board - Массив из 24 стэков (board[0..23]),
 *                                              каждый элемент — массив шашек [{ color:'white'|'black' }, ...].
 * @param {string} playerColor                 - 'white' или 'black'
 * @returns {boolean} true, если ход создаёт 6+ подряд (прайм), иначе false
 */

/**
 * Проверяет «правило прайма» для длинных нард, исходя из “хода врага”:

 * @param {Array<Array<{color:string}>>} board 
 *          Массив из 24 стэков (индексы 0..23).
 * @param {string} playerColor 
 *          Ваш цвет ('white' или 'black').
 * @return {boolean} true, если ход нарушает правило прайма, иначе false.
 */

 function violatesPrimeRule(_board, _currentPlayer) {
  // ХАЧАПУРИ: шесть занятых пунктов подряд разрешены без
  // дополнительного условия длинных нард.
  return false;
}


function isLegalMoveWithPrimeCheck(board, fromIndex, die, playerColor) {
  const pathToUse = playerColor === 'white' ? whiteLongPath : blackLongPath;
  const toIndex   = fromIndex + die;

  /* ───── BEAR‑OFF: только через canBearOff ───── */
  if (toIndex >= pathToUse.length) {
    const pointIdx = pathToUse[fromIndex] - 1;
    return canBearOff(board, playerColor, pointIdx, die);  // ✅ Строгая проверка
  }
  /* ────────────────────────────────────────────── */

  /* дальше — обычные проверки (прайм, битые пункты и т.п.) */
  const fromBoardIdx = pathToUse[fromIndex] - 1;
  const toBoardIdx   = pathToUse[toIndex]   - 1;

  if (!isMovePossible(board, pathToUse, fromIndex, die, playerColor))
    return false;

  // симуляция для проверки «прайма»
  const simulated = deepCopyBoard(board);
  const checker   = simulated[fromBoardIdx].pop();
  simulated[toBoardIdx].push(checker);

  return !violatesPrimeRule(simulated, playerColor);
}

//   function isLegalMoveWithPrimeCheck(board, fromIndex, die, playerColor) {
//   const pathToUse = playerColor === 'white' ? whiteLongPath : blackLongPath;
//   const toIndex   = fromIndex + die;

//   /* ───── BEAR‑OFF / overshoot ───── */
//   if (toIndex >= pathToUse.length) {
//     const pointIdx = pathToUse[fromIndex] - 1;   // индекс на board (0‑23)

//     /* 1.   классическое правило: все шашки уже дома? */
//     if (canBearOff(board, playerColor, pointIdx, die)) return true;

//     /* 2.   «мягкое» правило: после входа последней шашки все окажутся дома? */
//     const tmp = deepCopyBoard(board);
//     tmp[pointIdx].pop();                         // виртуально снимаем её с пункта
//     return allInHome(tmp, playerColor);          // true → разрешаем ход
//   }
//   /* ───────────────────────────────── */

//   /* дальше — обычные проверки (прайм, битые пункты и т.п.) */
//   const fromBoardIdx = pathToUse[fromIndex] - 1;
//   const toBoardIdx   = pathToUse[toIndex]   - 1;

//   if (!isMovePossible(board, pathToUse, fromIndex, die, playerColor))
//     return false;

//   // симуляция для проверки «прайма»
//   const simulated = deepCopyBoard(board);
//   const checker   = simulated[fromBoardIdx].pop();
//   simulated[toBoardIdx].push(checker);

//   return !violatesPrimeRule(simulated, playerColor);
// }




function calculateUsableDice(board, playerColor, diceArray) {
  board = safeParseBoard(board);

  if (playerColor !== 'white' && playerColor !== 'black') return 0;
  if (!Array.isArray(diceArray) || diceArray.length === 0) return 0;

  diceArray = diceArray.map(Number);
  if (diceArray.some((die) => !Number.isInteger(die) || die < 1 || die > 6)) {
    return 0;
  }

// ─── helper: перебираем все цепочки ходов ─────────────────────────
function dfs(boardState, diceLeft, headMoved = 0) {
  if (diceLeft.length === 0) return 0;
  const die        = diceLeft[0];
  const restDice   = diceLeft.slice(1);
  let   bestResult = 0;

  const pathToUse = playerColor === 'white' ? whiteLongPath : blackLongPath;

  for (let pos = 0; pos < pathToUse.length; pos++) {
    const fromIdx = pathToUse[pos] - 1;
    const fromStack = boardState[fromIdx];
    if (!Array.isArray(fromStack) || !fromStack.length ||
        fromStack[0]?.color !== playerColor) continue;

    const isHead = (fromIdx === headBoardIndex);
    if (isHead && headMoved >= headLimitFromHead) continue;

    if (!isLegalMoveWithPrimeCheck(boardState, pos, die, playerColor)) continue;

    const nextBoard = deepCopyBoard(boardState);
    const toPos     = pos + die;
    if (toPos >= pathToUse.length) {
      nextBoard[fromIdx].pop(); // bear-off
    } else {
      const toIdx = pathToUse[toPos] - 1;
      nextBoard[toIdx].push(nextBoard[fromIdx].pop());
    }

    bestResult = Math.max(
      bestResult,
      1 + dfs(nextBoard, restDice, headMoved + (isHead ? 1 : 0))
    );

    if (bestResult === diceArray.length) return bestResult; // максимум достигнут
  }

  return bestResult;
}


  const isDouble = diceArray[0] === diceArray[1];
  /* ===== Ограничение бросков с головы ===== */
const headBoardIndex    = playerColor === 'white' ? 23 : 11;   // индекс головы
const headStack         = Array.isArray(board[headBoardIndex]) ? board[headBoardIndex] : [];
const headCountBefore   = headStack.length;
const headLimitFromHead = maxHeadCheckers(headCountBefore, diceArray);
/* ======================================== */

  const dice = isDouble ? [diceArray[0], diceArray[0], diceArray[0], diceArray[0]] : diceArray;
  const path = playerColor === 'white' ? whiteLongPath : blackLongPath;
  const headIndex = playerColor === 'white' ? 23 : 11;
  const isWhite = playerColor === 'white';



 
  function chainMoves(posIndex, availableDice, depth = 0, boardState = board) {
  if (availableDice.length === 0) return 0;
  let max = 0;
  for (let i = 0; i < availableDice.length; i++) {
    const die = availableDice[i];
    const newPos = posIndex + die;




    /* ➊  ДОБАВЛЯЕМ обработку вывода  ---------------------------------- */
    if (newPos >= path.length) {                     // “за доской” ⇒ попытка bear-off
      const pointIdx = path[posIndex] - 1;           // реальный индекс 0-23
      if (canBearOff(boardState, playerColor, pointIdx, die)) {
        /* – симулируем снятие, чтобы следующий кубик видел новую доску */
        const tmp = deepCopyBoard(boardState);
        tmp[pointIdx].pop();
        const restDice = availableDice.filter((_, k) => k !== i);
        const sub = chainMoves(posIndex, restDice, depth + 1, tmp);  // ⚠️ posIndex НЕ меняется
        max = Math.max(max, 1 + sub);
      }
      continue;
    }



    if (newPos >= path.length) continue;
    if (!isLegalMoveWithPrimeCheck(boardState, posIndex, die, playerColor)) continue;

    // const restDice = [...availableDice];
    // restDice.splice(i, 1);
    // const subMoves = 1 + chainMoves(newPos, restDice, depth + 1, boardState);
        /* ➊  симулируем реальный ход, чтобы следующее проверяло уже новую доску */
    const tmp = deepCopyBoard(boardState);
    const fromIdx = path[posIndex] - 1;
    const toIdx   = path[newPos]   - 1;
    const checker = tmp[fromIdx].pop();
    tmp[toIdx].push(checker);

    const restDice = availableDice.filter((_, k) => k !== i);
    const subMoves = 1 + chainMoves(newPos, restDice, depth + 1, tmp);

    max = Math.max(max, subMoves);
  }
  return max;
}


  let totalMoves = 0;




  if (!isDouble) {
  const order1 = diceArray;
  const order2 = [...diceArray].reverse();

  totalMoves = Math.max(
    dfs(board, order1),
    dfs(board, order2)
  );
} else {
  totalMoves = dfs(board, dice, 0);
}




  return totalMoves;
}




function isMovePossible(board, path, pos, die, color) {
  if (!Array.isArray(board) || !Array.isArray(path)) return false;
  if (!Number.isInteger(pos) || !Number.isInteger(die) || die < 1 || die > 6) return false;

  const targetPos = pos + die;
  if (targetPos >= path.length) return allCheckersInHome(board, color);

  const pointNumber = path[targetPos];
  const targetBoardIndex = Number(pointNumber) - 1;
  if (!Number.isInteger(targetBoardIndex) || targetBoardIndex < 0 || targetBoardIndex >= 24) return false;

  const stack = board[targetBoardIndex];
  if (!Array.isArray(stack)) return false;
  if (stack.length > 0 && stack[0]?.color !== color) return false;

  // Для черных: запрет выхода из дома
  if (color === 'black') {
    const currentVisual = path[pos];
    if (currentVisual >= 13 && currentVisual <= 18 && path[targetPos] < 13) return false;
  }

  return true;
}


function isMovePossible(board, path, pos, die, color) {
  if (!Array.isArray(board) || !Array.isArray(path)) return false;
  if (!Number.isInteger(pos) || !Number.isInteger(die) || die < 1 || die > 6) return false;

  const targetPos = pos + die;
  if (targetPos >= path.length) {
    return allCheckersInHome(board, color);
  }

  const pointNumber = path[targetPos];
  const targetBoardIndex = Number(pointNumber) - 1;
  if (!Number.isInteger(targetBoardIndex) || targetBoardIndex < 0 || targetBoardIndex >= 24) return false;

  const stack = board[targetBoardIndex];
  if (!Array.isArray(stack)) return false;
  if (stack.length > 0 && stack[0]?.color !== color) return false;

  // Для черных: запрет выхода из дома
  if (color === 'black') {
    const currentVisual = path[pos];
    if (currentVisual >= 13 && currentVisual <= 18 && targetPos < 13) {
      return false;
    }
  }

  return true;
}









useEffect(() => {
  const storedUser = localStorage.getItem('username') || '';
  const numericTableId = Number(tableId);

  // F5 должен всегда заново получить серверный snapshot текущего стола.
  hasFetchedRef.current = false;

  if (!storedUser || !Number.isInteger(numericTableId) || numericTableId <= 0) {
    setLongError('Нет username или некорректный tableId');
    setLongLoading(false);
    return undefined;
  }

  setUsername(storedUser);
  setLongError('');
  setLongLoading(true);

  // Убираем старый ошибочный snapshot, который мог остаться от ранней версии Хачапури.
  try {
    localStorage.removeItem(`long:snap:${numericTableId}`);
    localStorage.setItem('gameType', 'khachapuri');
  } catch (e) {}

  // 2. Обработчик longGameUpdated
  function handleGameUpdated(game) {
    console.log('[DEBUG] longGameUpdated получен:', game);

    if (!game) return;

    if (
      khachapuriOpeningRef.current.active &&
      !Boolean(game.firstRollComplete) &&
      !Boolean(game.firstMoveComplete)
    ) {
      console.log('[KHACHAPURI] stale pre-start gameUpdated ignored', {
        tableId: game.khachapuri_table_id || game.long_table_id,
      });
      return;
    }


    const incomingTableId = Number(
  game.long_table_id ??
  game.longTableId ??
  game.tableId ??
  game.LongTable?.id
);

const currentUrlTableId =
  Number(tableId);

if (
  Number.isInteger(incomingTableId) &&
  Number.isInteger(currentUrlTableId) &&
  incomingTableId !== currentUrlTableId
) {
  console.warn(
    '[LONG] проигнорировано событие чужого стола:',
    {
      incomingTableId,
      currentUrlTableId
    }
  );

  return;
}


  // 🔹 ДОБАВЬ ЭТО: показать «до скольки» сразу при заходе
  const tp =
    game.targetPoints ??
    game.target_points ??
    game.matchTo ??
    game.match_to ??
    game.LongTable?.target_points ??
    game.LongTable?.match_to;

  if (tp != null) setTargetPoints(Number(tp) || 1);

  // Сервер Хачапури хранит реальный номер партии отдельно от очков.
  const incomingRound =
    game.round_number ??
    game.roundNumber ??
    (
      game.rounds_completed != null
        ? Number(game.rounds_completed) + 1
        : null
    );

  if (incomingRound != null) {
    const n = Number(incomingRound);
    if (Number.isFinite(n) && n > 0) setCurrentGameNumber(Math.floor(n));
  }

  // Текущий ход должен обновляться не только при первом snapshot.
  // Иначе первый игрок, который уже открыл пустой стол, навсегда оставался
  // с current_turn=null до F5, если одноразовый auto-roll event был пропущен.
  setLongCurrentTurn(game.current_turn || null);

  const gameOpeningFlag =
    Boolean(game.khachapuri_opening_active) ||
    (
      Boolean(game.firstRollComplete) &&
      !Boolean(game.firstMoveComplete)
    );

  if (gameOpeningFlag) {
    const starter =
      game.khachapuri_round_starter === 'player2' ||
      game.current_turn === 'player2'
        ? 'player2'
        : 'player1';

    const p1Rolls = normalizeRolls(game.player1_rolls);
    const p2Rolls = normalizeRolls(game.player2_rolls);

    const dedicatedDice = Array.isArray(game.khachapuri_opening_dice)
      ? game.khachapuri_opening_dice.map(Number).slice(0, 2)
      : [];

    const fallbackDice =
      starter === 'player1'
        ? (p1Rolls.at(-1) || [])
        : (p2Rolls.at(-1) || []);

    const openingDice =
      dedicatedDice.length >= 2
        ? dedicatedDice
        : fallbackDice.map(Number).slice(0, 2);

    if (
      openingDice.length >= 2 &&
      Number.isInteger(openingDice[0]) &&
      openingDice[0] >= 1 &&
      openingDice[0] <= 6 &&
      Number.isInteger(openingDice[1]) &&
      openingDice[1] >= 1 &&
      openingDice[1] <= 6
    ) {
      khachapuriRoundStartHandlerRef.current?.({
        tableId: incomingTableId || currentUrlTableId,
        round: Number(game.round_number || 1),
        starter,
        dice: openingDice,
        numberMove: Number(
          game.khachapuri_opening_number_move ||
          (openingDice[0] === openingDice[1] ? 4 : 2)
        ),
        player1_name: game.player1_name || '',
        player2_name: game.player2_name || '',
        replay: true,
      });
    }
  }


    // --- Доску грузим только один раз ---
    if (!hasFetchedRef.current) {
      let parsedBoard;
      try {
        parsedBoard = typeof game.board_state === 'string'
          ? JSON.parse(game.board_state)
          : game.board_state;
      } catch (e) {
        console.error('[Long] parse board_state error:', e);
        parsedBoard = Array(24).fill([]);
      }

      setLongBoardState(parsedBoard);

      if (game.off_board) {
        try {
          const off = typeof game.off_board === 'string'
            ? JSON.parse(game.off_board)
            : game.off_board;

          setLongWhiteOffBoard(off.white || []);
          setLongBlackOffBoard(off.black || []);
        } catch (e) {
          console.error('[Long] parse off_board error:', e);
        }
      }

      setLongCurrentTurn(game.current_turn);
      setMaxBet(game.LongTable?.max_bet || 0);
      setInitialBet(parseFloat(game.initial_bet) || 1);
      
       
      // rememberLongRoom(Number(tableId), storedUser);
      setLongLoading(false);
      hasFetchedRef.current = true;
    }

    // --- А имена обновляем ВСЕГДА ---
    setLongPlayer1Name(game.player1_name || '');
    setLongPlayer2Name(game.player2_name || '');

    /* ⬇︎ НОВОЕ: аватарки обновляем ВСЕГДА */
const p1AvaRaw =
  game.longPlayer1Avatar ??
  game.player1_avatar ??
  game.player1Avatar ??
  game.player1_avatar_url ??
  '';
const p2AvaRaw =
  game.longPlayer2Avatar ??
  game.player2_avatar ??
  game.player2Avatar ??
  game.player2_avatar_url ??
  '';

setLongPlayer1Avatar(normUrl(p1AvaRaw));
setLongPlayer2Avatar(normUrl(p2AvaRaw));



    const isMePlayer1 = game.player1_name === storedUser;
    setLongMyColor(isMePlayer1 ? 'white' : 'black');
  }


  function handleJoinError(msg) {
    const text = typeof msg === 'string' ? msg : (msg?.message || msg?.error || 'Ошибка подключения к столу');
    setLongLoading(false);
    setInfoModal({
      open: true,
      title: 'Хачапури — ошибка входа',
      message: String(text),
      primaryText: 'Вернуться в лобби',
      onPrimary: () => {
        setInfoModal(m => ({ ...m, open: false }));
        navigate('/', { replace: true });
      }
    });
  }

  // ВАЖНО: подписываемся ДО connect/join.
  // На F5 сервер может прислать snapshot сразу после восстановления комнаты.
  // Сервер присылает один и тот же snapshot и как longGameUpdated,
  // и как khachapuriGameUpdated. Для Хачапури применяем его один раз.
  longSocket.on('khachapuriGameUpdated', handleGameUpdated);
  longSocket.on('long_joinError', handleJoinError);
  longSocket.on('khachapuri_joinError', handleJoinError);

  const fetchSnapshot = () => {
    // Один авторитетный snapshot. Сервер сам отправляет всё необходимое:
    // khachapuriGameUpdated + longDataResponse + replay opening roll.
    longSocket.emit('khachapuriFetchData', { tableId: numericTableId });
  };

  const joinAndFetch = () => {
    longSocket.emit(
      'joinKhachapuriTable',
      {
        tableId: numericTableId,
        playerUsername: storedUser,
        isSpectator,
      },
      (ack) => {
        console.log('[KHACHAPURI] join ACK:', ack);

        if (ack?.ok) {
          rememberLongRoom(numericTableId, storedUser, isSpectator);

          if (isSpectator) {
            fetchSnapshot();
            return;
          }

          let readyFinished = false;

          const finishReady = (readyAck) => {
            if (readyFinished) return;
            readyFinished = true;

            console.log('[KHACHAPURI] ready ACK:', readyAck);
            fetchSnapshot();
          };

          longSocket.emit(
            'khachapuri_readyForRound',
            { tableId: numericTableId },
            finishReady
          );

          // Только fallback для потерянного ACK.
          // Сам ROUND_START всё равно разрешает исключительно сервер READY-map.
          window.setTimeout(
            () => finishReady({ timeout: true }),
            900
          );

          return;
        }

        if (ack?.blocked || ack?.redirected || ack?.code === 'active_game') {
          const activeTableId = Number(ack.activeTableId ?? ack.tableId);
          if (!Number.isInteger(activeTableId) || activeTableId <= 0) return;

          clearLongRoom();
          rememberLongRoom(activeTableId, storedUser, false);
          window.location.replace(`/khachapuriGame/${activeTableId}`);
        }
      }
    );
  };

  const handleConnect = () => {
    joinAndFetch();
  };

  if (longSocket.connected) {
    joinAndFetch();
  } else {
    longSocket.once('connect', handleConnect);
    ensureLongSocketAuthAndConnect();
  }

  return () => {
    longSocket.off('connect', handleConnect);
    longSocket.off('khachapuriGameUpdated', handleGameUpdated);
    longSocket.off('long_joinError', handleJoinError);
    longSocket.off('khachapuri_joinError', handleJoinError);
  };
}, [tableId, isSpectator, navigate]);




useEffect(() => {
  if (!autoConfirm) return;

  const myRole = (longMyColor === 'white') ? 'player1' : 'player2';
  const isMyTurn = (longCurrentTurn === myRole);

  if (
    isMyTurn &&
    longHasRolledDice &&
    longNumberMove === 0 &&
    !isSpectator &&
    longMoveHistory.length > 0     // ← добавили КОРРЕКТНО
  ) {
    const t = setTimeout(() => {
      longConfirmMove();
    }, 120);
    return () => clearTimeout(t);
  }
}, [
  autoConfirm,
  longCurrentTurn,
  longMyColor,
  longHasRolledDice,
  longNumberMove,
  isSpectator,
  longMoveHistory,      // ← ОБЯЗАТЕЛЬНО
  longConfirmMove
]);



useEffect(() => {
  if (!autoRoll) return; // авто-ролл выключен
  const myRole = (longMyColor === 'white') ? 'player1' : 'player2';
  const isMyTurn = (longCurrentTurn === myRole);

  // бросаем только когда мой ход и в этот ход я ещё не кидал
  if (isMyTurn && !longHasRolledDice && !isSpectator) {
    handleLongRollDiceClick(); // твоя же функция броска
  }
}, [autoRoll, longCurrentTurn, longMyColor, longHasRolledDice, isSpectator]);


// useEffect(() => {
//   const storedUser = localStorage.getItem('username') || '';
//   if (!storedUser || !tableId) {
//     setLongLoading('Нет username или tableId');
//     setLongLoading(false);
//     return;
//   }

//   setUsername(storedUser);

//   if (!longSocket.connected) longSocket.connect();

//   // 1. Присоединяемся к комнате
//   longSocket.emit('joinLongTable', {
//     longTableId: parseInt(tableId, 10),
//     playerUsername: storedUser,
//     isSpectator,
//   });


//   longSocket.on('long_joinError', (msg) => {
//   alert(msg);
//   window.location.href = '/'; // возвращаем в лобби
// });


//   // 2. Обработчик longGameUpdated (но только если longFetchData ещё НЕ приходил)
//   function handleGameUpdated(game) {
//     if (!game || hasFetchedRef.current) return;

//     let parsedBoard;
//     try {
//       parsedBoard = typeof game.board_state === 'string'
//         ? JSON.parse(game.board_state)
//         : game.board_state;
//     } catch (e) {
//       console.error('[Long] parse board_state error:', e);
//       parsedBoard = Array(24).fill([]);
//     }

//     setLongBoardState(parsedBoard);

//     if (game.off_board) {
//       try {
//         const off = typeof game.off_board === 'string'
//           ? JSON.parse(game.off_board)
//           : game.off_board;

//         setLongWhiteOffBoard(off.white || []);
//         setLongBlackOffBoard(off.black || []);
//       } catch (e) {
//         console.error('[Long] parse off_board error:', e);
//       }
//     }

//     setLongCurrentTurn(game.current_turn);
//     // 👇 ВСТАВЬ ВОТ СЮДА:


// setLongPlayer1Name(game.player1_name || '');
// setLongPlayer2Name(game.player2_name || '');

// const isMePlayer1 = game.player1_name === storedUser;
// setLongMyColor(isMePlayer1 ? 'white' : 'black');
//     setLongPlayer1Name(game.player1_name || '');
//     setLongPlayer2Name(game.player2_name || '');
// setMaxBet(game.LongTable?.max_bet || 0);
// setInitialBet(parseFloat(game.initial_bet) || 1);
    
//     // ✅ ДОБАВЬ ЭТИ ДВЕ СТРОКИ:
//   setLongLoading(false);
//   hasFetchedRef.current = true;
//   }

//   longSocket.on('longGameUpdated', handleGameUpdated);

//   return () => {
//     longSocket.off('longGameUpdated', handleGameUpdated);
//     longSocket.off('long_joinError');
//   };
// }, [tableId]);





  useEffect(() => {
    function handleDiceRolled(data) {

  
      if (data.longTableId !== parseInt(tableId, 10)) return;
  
      const myColor = localStorage.getItem("username") === data.player1_name ? "white" : "black";
      const isWhite = myColor === 'white';
      const headIndex = isWhite ? 23 : 11;
      const isMyTurn =
        (myColor === "white" && data.currentPlayer === "player1") ||
        (myColor === "black" && data.currentPlayer === "player2");
  
      const lastRoll = data.currentPlayer === "player1"
        ? data.player1_rolls[data.player1_rolls.length - 1]
        : data.player2_rolls[data.player2_rolls.length - 1];
  
      if (!Array.isArray(lastRoll) || lastRoll.length < 2) {
        console.warn("⚠️ lastRoll невалидный:", lastRoll);
        setLongNumberMove(0);
        return;
      }
  
      const [d1, d2] = lastRoll;
      const isDouble = d1 === d2;
      const dice = isDouble ? [d1, d1, d1, d1] : [d1, d2];
      const maxMoves = dice.length;

      console.log('[KHACHAPURI][DICE_ROLLED][CLIENT]', {
        currentPlayer: data.currentPlayer,
        myColor,
        isMyTurn,
        lastRoll,
        numberMove: data.numberMove,
      });

      setRolledByPlayer(data.currentPlayer);
      setLongRolledDice(lastRoll);
  
      if (!isMyTurn) {
        setLongNumberMove(data.numberMove || 0);
        return;
      }
  
      setLongDiceValues(dice);
      setLongHasRolledDice(true);
  
      // === [1] Запоминаем голову ===
      if (headInitialCountRef.current === null) {
        headInitialCountRef.current = longBoardState[headIndex]?.length || 0;
      }
  
      // === [2] Подсчёт реальных ходов ===
      const usableCount = calculateUsableDice(longBoardState, myColor, dice);
  
  
      if (usableCount === 0) {
 
        setLongNumberMove(0);
        // longConfirmMove();
        return;
      }
  
      setLongNumberMove(usableCount);
  
      // === [3] Отправка на сервер ===
      longSocket.emit('long_updateNumberMove', {
        longTableId: parseInt(tableId, 10),
        currentPlayer: data.currentPlayer,
        longNumberMove: usableCount
      });
       setDoubleJustTaken(false);
    }
  
    longSocket.on("longGame_diceRolled", handleDiceRolled);
    return () => {
      longSocket.off("longGame_diceRolled", handleDiceRolled);
    };
  }, [tableId, longBoardState, headMoveCount]);
  
  
  


// const longLeaveTable = () => {
//   if (!tableId || !username) return;
// console.log('123456');

//   longSocket.emit('longLeaveTable', {
//     tableId: parseInt(tableId, 10),
//     player: username,
//   });

//   // window.location.href = '/'; // редирект в лобби
//   navigate('/', { replace: true })
// };

const longLeaveTable = () => {
  if (!tableId || !username) return;

  console.log('[leave] before emit 123456', { tableId, username });

  let done = false;
  const goHome = (reason) => {
    if (done) return;
    done = true;
    console.log('[leave] navigate -> lobby, reason:', reason);
    navigate('/', { replace: true });
  };

  // таймаут на случай, если ack не придёт
  const t = setTimeout(() => goHome('timeout'), 400);

  longSocket.emit(
    'longLeaveTable',
    { tableId: Number(tableId), player: username },
    (res) => {
      clearTimeout(t);
      console.log('[leave] ack 123456', res);
      goHome('ack');
    }
  );
};







  const handleLongRollDiceClick = () => {
    

    /*
     * Весь интерфейс Хачапури определяет роль через longMyColor.
     * Раньше здесь использовался отдельный longPlayerColor.
     * После dedicated ROUND_START эти state могли кратко расходиться:
     * UI показывал кнопку, а click молча делал return.
     */
    const myRole = longMyColor === 'white' ? 'player1' : 'player2';
    const isMyTurn = longCurrentTurn === myRole;

    if (!isMyTurn || longHasRolledDice || waitingDoubleReply || doubleProposal) {
      console.log('[KHACHAPURI][ROLL_CLICK] blocked', {
        myRole,
        longCurrentTurn,
        longMyColor,
        longHasRolledDice,
        waitingDoubleReply,
        hasDoubleProposal: !!doubleProposal,
      });
      return;
    }

      /*
       * Не ставим longHasRolledDice=true заранее.
       * Этот флаг выставится только после настоящего
       * longGame_diceRolled от сервера.
       */
      setLongRollEnabled(false);
      setLongInitialRollPhase(true);
    // console.log('[emit] ShortBackgammon_rollDice =>', {
    //   longTableId: parseInt(tableId, 10),
    //   currentPlayer: longCurrentTurn
    // });
  
    // if (isMyTurn && !longHasRolledDice) {
    setWaitingDoubleReply(false);
    setDoubleJustTaken(false);

      console.log('[KHACHAPURI][ROLL_CLICK] emit', {
        tableId: parseInt(tableId, 10),
        currentPlayer: longCurrentTurn,
        myRole,
        longMyColor,
      });

      longSocket.emit('longGame_rollDice', {
        longTableId: parseInt(tableId, 10),
        currentPlayer: longCurrentTurn
      });
    
    // }
 
  };


 


  // const whitePath = [24,23,22,21,20,19,18,17,16,15,14,13, 12,11,10,9,8,7, 6,5,4,3,2,1];
  // const blackPath = [12,11,10,9,8,7,6,5,4,3,2,1, 24,23,22,21,20,19, 18,17,16,15,14,13];

  const whiteLongPath = [
    24, 23, 22, 21, 20, 19, 18,
    17, 16, 15, 14, 13,
    12, 11, 10, 9, 8, 7,
     6, 5, 4, 3, 2, 1
  ];
  
  const blackLongPath = [
    12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1,
    24, 23, 22, 21, 20, 19,
    18, 17, 16, 15, 14, 13
  ];

  
// Конвертация индекса, который приходит от UI в реальный индекс доски
const visualIndexToRealIndex = (uiIndex) => {
  if (uiIndex >= 0 && uiIndex <= 11) {
    return 11 - uiIndex; // нижний ряд (визуально: 12 → 1)
  } else if (uiIndex >= 12 && uiIndex <= 23) {
    return 35 - uiIndex; // верхний ряд (визуально: 13 → 24)
  }
}; 
// const visualIndexToRealIndex = (uiIndex) => 23 - uiIndex;
const indexToVisualNumber = (index) => index + 1;






const longOnPointClick = (uiIndex) => {
  // Преобразуем визуальный индекс в реальный (0–23)
  const index = visualIndexToRealIndex(uiIndex);
  const visualNumber = indexToVisualNumber(index);



  if (!longDiceValues.length || longNumberMove <= 0) {

    return;
  }

  const newBoard = deepCopyBoard(longBoardState);
  /* ---------- SOURCE-CHECK ------------------------------------ */
if (
  !newBoard[index]?.length ||                                   // пусто
  newBoard[index][newBoard[index].length - 1].color !== longMyColor
) {
 
  return;                                                       // прерываем обработчик
}
/* ------------------------------------------------------------- */

  const isWhite = longMyColor === 'white';
  const isBlack = longMyColor === 'black';
  // Для белых голова – визуально 24 (индекс 23), для чёрных – визуально 12 (индекс 11)
  const whiteHeadIndex = 23;
  const blackHeadIndex = 11;
  const isFromHead = (isWhite && index === whiteHeadIndex) ||
                     (isBlack && index === blackHeadIndex);
// Определяем originalDice один раз, чтобы дальше везде было доступно:
const originalDice =
  Array.isArray(longRolledDice) && longRolledDice.length >= 2
    ? [longRolledDice[0], longRolledDice[1]]
    : (longDiceValues.length >= 2
        ? [longDiceValues[0], longDiceValues[1]]
        : [...longDiceValues]);

  // Проверяем ограничения для хода с головы
  let isFullHead = false;
  let isDouble = false;
  if (isFromHead) {


    // Если это первый ход с головы в текущем раунде, фиксируем изначальное количество шашек
    if (headInitialCountRef.current === null) {
      headInitialCountRef.current = newBoard[index].length;
    }
  
// ХАЧАПУРИ: отдельного лимита на количество шашек с головы НЕТ.
    // Ограничение задают только оставшиеся кубики/ходы:
    // обычный бросок = максимум 2 хода, куш = максимум 4 хода.
    // Поэтому здесь НЕ блокируем четвёртую шашку при дубле.

 
  

  }

  // Сохраняем состояние для undo
  const prevNumberMove = longNumberMove;
  const prevDiceValues = [...longDiceValues];
  const boardBefore = deepCopyBoard(longBoardState);
/* ---------- B E A R  O F F ------------- */
{
  // сортируем кубики от большего к меньшему — так требует правило
  const dieForBear = [...longDiceValues]
                       .sort((a, b) => b - a)
                       .find(d => canBearOff(longBoardState, longMyColor, index, d));

  if (dieForBear !== undefined) {
    // можно вынести шашку — делаем это и завершаем обработчик
    performBearOff(index, dieForBear);
    return;
  }
}
/* --------------------------------------- */

  // Подготавливаем оставшиеся кубики (если дубль – расширяем массив)
  let remainingDice = [...longDiceValues];
  if (remainingDice.length === 2 && remainingDice[0] === remainingDice[1]) {
    remainingDice = [remainingDice[0], remainingDice[0], remainingDice[0], remainingDice[0]];
  }
  remainingDice.sort((a, b) => b - a);
  const direction = -1;
  let chosenDie = null;
  let targetIndex = -1;
  let foundMove = false;
  for (let dieVal of remainingDice) {
    let tempTarget = index + dieVal * direction;
    if (longMyColor === 'black' && tempTarget < 0) {
      tempTarget = 24 + tempTarget;
    }
    if (tempTarget < 0 || tempTarget > 23) continue;
    if (longMyColor === 'black') {
      const currentPoint = index + 1;
      const targetPoint = tempTarget + 1;
      if (currentPoint >= 13 && currentPoint <= 18 && targetPoint < 13) continue;
    }
    const stackAtTarget = newBoard[tempTarget];
    if (stackAtTarget.length > 0 && stackAtTarget[0].color !== longMyColor) continue;
    chosenDie = dieVal;
    targetIndex = tempTarget;
    foundMove = true;
    break;
  }

  if (!foundMove) {

    return;
  }

  // Выполняем ход: перемещаем шашку с пункта index в пункт targetIndex
  if (newBoard[index]?.length) {
    const topChecker = newBoard[index][newBoard[index].length - 1];
    if (topChecker.color === longMyColor) {
      newBoard[index].pop();
      newBoard[targetIndex].push(topChecker);
      if (violatesPrimeRule(newBoard, longMyColor)) {
 
        return;
      }
      setLongMoveHistory((prev) => [
        ...prev,
        {
          from: index,
          to: targetIndex,
          boardBefore,
          diceUsed: [chosenDie],
          prevNumberMove,
          prevDiceValues,
        },
      ]);

      // Если ход с головы – увеличиваем headMoveCount
      let localHeadMoveCount = headMoveCount;
      if (isFromHead) {
      localHeadMoveCount++;
    setHeadMoveCount(localHeadMoveCount);
    setHeadCheckersMoved(c => c + 1);
      }

      // Если ход с головы с допустимым дублем (то есть изначально было ровно 15 шашек),
      // то оставшееся число ходов должно быть 2 минус число уже совершённых ходов.
      
      if (isFromHead && isFullHead && isDouble) {
        const dieVal = originalDice[0];
        let maxMovesFromHead = 1;
        if (dieVal === 3 || dieVal === 4) {
          maxMovesFromHead = 4;
        } else if (dieVal === 6) {
          maxMovesFromHead = 2;
        }
      
        const newNumberMove = maxMovesFromHead - localHeadMoveCount;
        setLongNumberMove(newNumberMove);
      
        
        longSocket.emit('longGame_updateBoardState', {
          longTableId: parseInt(tableId, 10),
          boardState: newBoard,
          longWhiteOffBoard,
          longBlackOffBoard,
          longNumberMove: newNumberMove,
        });
      } else {
        setLongNumberMove(prev => prev - 1);
        longSocket.emit('longGame_updateBoardState', {
          longTableId: parseInt(tableId, 10),
          boardState: newBoard,
          longWhiteOffBoard,
          longBlackOffBoard,
          longNumberMove: longNumberMove - 1,
        });
      }

      // Удаляем использованный кубик из longDiceValues
      const newDiceValues = [...longDiceValues];
      const dieIndex = newDiceValues.indexOf(chosenDie);
      if (dieIndex > -1) {
        newDiceValues.splice(dieIndex, 1);
      }
      setLongDiceValues(newDiceValues);
      setLongBoardState(newBoard);

     
    } else {
    
    }
  } else {
   
  }
  setLongLastMoveType('click');
};
















function checkAvailableMoves(board, playerColor, diceArray) {
  const availableMoves = [];
  // Перебираем все точки на доске
  for (let pos = 0; pos < board.length; pos++) {
    // Если в точке есть шашка нужного цвета
    if (board[pos].length > 0 && board[pos][0].color === playerColor) {
      diceArray.forEach(die => {
        const targetPos = calculateTarget(pos, die, playerColor);
        if (targetPos !== null && isMoveAllowed(board, pos, targetPos, playerColor)) {
          // Логируем конкретный ход: с какого пункта на какой, используя какой кубик
       
          availableMoves.push({ from: pos, to: targetPos, die });
        }
      });
    }
  }
  // Лог общего количества найденных ходов
 
  return availableMoves;
}
 
// Пример функции, вычисляющей целевую позицию (с учетом направления, wrap-around и ограничений)
function calculateTarget(from, die, playerColor) {
  const direction = (playerColor === 'white') ? -1 : 1;
  let target = from + die * direction;
  // Если позиция выходит за границы – вернуть null (или обработать wrap-around для определённых ситуаций)
  if (target < 0 || target > 23) return null;
  return target;
}

// Пример функции, проверяющей, можно ли походить из from в target (учитывая блокировки и домашнюю зону)
function isMoveAllowed(board, from, target, playerColor) {
  // Если целевая точка пуста, или содержит шашки того же цвета – ход допустим.
  const targetStack = board[target];
  if (!targetStack || targetStack.length === 0) return true;
  if (targetStack[0].color === playerColor) return true;
  return false;
}










function hasLegalMoveForDie(board, die, playerColor) {
  const path = playerColor === 'white' ? whiteLongPath : blackLongPath;

  for (let pos = 0; pos < path.length; pos++) {
    const boardIdx = path[pos] - 1;
    if (!board[boardIdx].length) continue;
    if (board[boardIdx][0].color !== playerColor) continue;

    if (isLegalMoveWithPrimeCheck(board, pos, die, playerColor))
      return true;                       // ← нашли ход → true
  }
  return false;
}







// Позволяет перетащить шашку сразу на сумму двух кубиков (d1→d2 или d2→d1).
// Возвращает true, если ход применён, иначе false.
const tryTwoDiceDragMove = (fromIndex, toIndex) => {
  if (longNumberMove < 2) return false;
  if (!Array.isArray(longDiceValues) || longDiceValues.length < 2) return false;

  const path = (longMyColor === 'white') ? whiteLongPath : blackLongPath;
  const fromPos = path.findIndex(p => p - 1 === fromIndex);
  const toPos   = path.findIndex(p => p - 1 === toIndex);
  if (fromPos === -1 || toPos === -1) return false;

  const need = toPos - fromPos;
  if (need <= 0) return false; // двигаемся только "вперёд" по маршруту

  // bear-off через эту фичу не делаем, только клетка→клетка
  const stepOnce = (board, pos, die) => {
    const nextPos = pos + die;
    if (nextPos >= path.length) return null;
    if (!isLegalMoveWithPrimeCheck(board, pos, die, longMyColor)) return null;

    const nb = deepCopyBoard(board);
    const fromB = path[pos]    - 1;
    const toB   = path[nextPos]- 1;

    // цель не должна быть занята соперником
    if (nb[toB].length && nb[toB][0].color !== longMyColor) return null;

    const ch = nb[fromB].pop();
    nb[toB].push(ch);
    return { board: nb, pos: nextPos };
  };

  // вычислим, с головы ли ход
  const isFromHead =
    (longMyColor === 'white' && fromIndex === 23) ||
    (longMyColor === 'black' && fromIndex === 11);

  // перебираем пары кубиков i != j и оба порядка
  for (let i = 0; i < longDiceValues.length; i++) {
    for (let j = 0; j < longDiceValues.length; j++) {
      if (i === j) continue;
      const d1 = longDiceValues[i], d2 = longDiceValues[j];
      if (d1 + d2 !== need) continue;

      // порядок d1 -> d2
      let r1 = stepOnce(longBoardState, fromPos, d1);
      if (r1) {
        let r2 = stepOnce(r1.board, r1.pos, d2);
        if (r2 && r2.pos === toPos) {
          // применяем
          const boardBefore    = deepCopyBoard(longBoardState);
          const prevNumberMove = longNumberMove;
          const prevDiceValues = [...longDiceValues];

          // списать эти ДВА кубика по индексам (чтобы при дублях снять ровно два)
          const newDice = [...longDiceValues];
          // важно — сначала удалить больший индекс
          const i1 = Math.max(i, j), i2 = Math.min(i, j);
          newDice.splice(i1, 1);
          newDice.splice(i2, 1);

          if (isFromHead) {
            if (headInitialCountRef.current == null) {
              headInitialCountRef.current = longBoardState[fromIndex]?.length || 0;
            }
            setHeadMoveCount(v => v + 1);
            setHeadCheckersMoved(v => v + 1);
          }

          setLongMoveHistory(prev => [...prev, {
            type: 'drag',
            from: fromIndex,
            to  : toIndex,
            diceUsed: [d1, d2],
            boardBefore,
            prevNumberMove,
            prevDiceValues
          }]);

          setLongBoardState(r2.board);
          setLongDiceValues(newDice);
          setLongNumberMove(n => n - 2);
          setLongLastMoveType('drag');

          longSocket.emit('longGame_updateBoardState', {
            longTableId: parseInt(tableId, 10),
            boardState: r2.board,
            longWhiteOffBoard,
            longBlackOffBoard,
            longNumberMove: prevNumberMove - 2
          });
          return true;
        }
      }

      // порядок d2 -> d1
      let a1 = stepOnce(longBoardState, fromPos, d2);
      if (a1) {
        let a2 = stepOnce(a1.board, a1.pos, d1);
        if (a2 && a2.pos === toPos) {
          const boardBefore    = deepCopyBoard(longBoardState);
          const prevNumberMove = longNumberMove;
          const prevDiceValues = [...longDiceValues];

          const newDice = [...longDiceValues];
          const i1 = Math.max(i, j), i2 = Math.min(i, j);
          newDice.splice(i1, 1);
          newDice.splice(i2, 1);

          if (isFromHead) {
            if (headInitialCountRef.current == null) {
              headInitialCountRef.current = longBoardState[fromIndex]?.length || 0;
            }
            setHeadMoveCount(v => v + 1);
            setHeadCheckersMoved(v => v + 1);
          }

          setLongMoveHistory(prev => [...prev, {
            type: 'drag',
            from: fromIndex,
            to  : toIndex,
            diceUsed: [d2, d1],
            boardBefore,
            prevNumberMove,
            prevDiceValues
          }]);

          setLongBoardState(a2.board);
          setLongDiceValues(newDice);
          setLongNumberMove(n => n - 2);
          setLongLastMoveType('drag');

          longSocket.emit('longGame_updateBoardState', {
            longTableId: parseInt(tableId, 10),
            boardState: a2.board,
            longWhiteOffBoard,
            longBlackOffBoard,
            longNumberMove: prevNumberMove - 2
          });
          return true;
        }
      }
    }
  }

  return false;
};



  // ==============================
  // Drag & Drop
  // ==============================
  const longHandleDragStart = (e, fromUIIndex, checkerIndex) => {
   
    const dragData = { fromUIIndex, checkerIndex };
    e.dataTransfer.setData('text/plain', JSON.stringify(dragData));
    
  };

  const longHandleDragOver = (e) => {
    e.preventDefault(); // разрешаем drop
  
  };


  const longHandleDrop = (e, dropUIIndex) => {
  
    e.preventDefault();
   
  // dropUIIndex уже является реальным индексом (realIndex), не нужно его преобразовывать ещё раз!
  if (!longDiceValues?.length || longNumberMove <= 0) {
  
    return;
  }
 
  const rawData = e.dataTransfer.getData('text/plain');
  if (!rawData) {

  return;}

  const { fromUIIndex, checkerIndex } = JSON.parse(rawData);
 
// 🔁 Преобразуем визуальные индексы в "белую" ориентацию для чёрных
// Преобразование UI-индексов для чёрных (если они в перевёрнутом виде)









const mapUIIndexForColor = (uiIndex) => {
  if (longMyColor === 'black') {
    // UI индексы 0..11 => bottom row => реальные 12..23
    // UI индексы 12..23 => top row => реальные 11..0
    if (uiIndex <= 11) return 12 + uiIndex;
    else return 35 - uiIndex;
  }
  return uiIndex; // для белых — без изменений
};


// 🔁 Преобразуем UI индексы в реальные индексы, как при клике:
const fromIndex = visualIndexToRealIndex(fromUIIndex);
const toIndex = visualIndexToRealIndex(dropUIIndex);







if (
  longNumberMove === 1 &&
  longDiceValues.length === 2 &&
  longDiceValues[0] !== longDiceValues[1]
) {
  const [bigDie, smallDie] = [...longDiceValues].sort((a, b) => b - a);





  
  const path = longMyColor === 'white' ? whiteLongPath : blackLongPath;
  const getPathIndex = (boardIndex) => path.findIndex(p => p - 1 === boardIndex);
  const fromPos = getPathIndex(fromIndex);
  const toPos = getPathIndex(toIndex);
  const dieUserAsked = Math.abs(toPos - fromPos);

  console.log('[DEBUG] PRIORITY CHECK:');
  console.log('color:', longMyColor);
  console.log('fromIndex:', fromIndex, '→ fromPos:', fromPos);
  console.log('toIndex:', toIndex, '→ toPos:', toPos);
  console.log('user asked die:', dieUserAsked);
  console.log('dice:', longDiceValues, '→ big:', bigDie, 'small:', smallDie);
  console.log('hasLegalMoveForDie(bigDie):', hasLegalMoveForDie(longBoardState, bigDie, longMyColor));

  if (
    dieUserAsked === smallDie &&
    hasLegalMoveForDie(longBoardState, bigDie, longMyColor)
  ) {
    console.warn('[PRIORITY BLOCKED] Ход на меньший кубик запрещён:', {
      dieUserAsked,
      bigDie,
      smallDie,
      color: longMyColor
    });
    return;
  }
}




  if (fromIndex < 0 || fromIndex > 23 || toIndex < 0 || toIndex > 23) {

    return;
  }
    // 4) Копируем доску
    const newBoard = deepCopyBoard(longBoardState);
  
    // 5) Проверяем, есть ли вообще шашка нашего цвета в точке fromIndex
    if (!newBoard[fromIndex] || newBoard[fromIndex].length === 0) {

      return;
    }



    const whiteHeadIndex = 23;
    const blackHeadIndex = 11;
    const isFromHead1 = (longMyColor === 'white' && fromIndex === whiteHeadIndex) ||
                       (longMyColor === 'black' && fromIndex === blackHeadIndex);
    
    // --- Проверка хода с головы (drag & drop) ---
    if (isFromHead1) {

    
      if (headInitialCountRef.current === null) {
        headInitialCountRef.current = newBoard[fromIndex].length;
      }
      const initialHeadCount = headInitialCountRef.current;
      const isFullHead = (initialHeadCount === 15);
    
      const originalDice =
        Array.isArray(longRolledDice) && longRolledDice.length >= 2
          ? [longRolledDice[0], longRolledDice[1]]
          : (longDiceValues.length >= 2
              ? [longDiceValues[0], longDiceValues[1]]
              : [...longDiceValues]);
    
      const validDouble = [3, 4, 6].includes(originalDice[0]);
      const isDouble = (
        originalDice.length === 2 &&
        originalDice[0] === originalDice[1] &&
        isFullHead &&
        validDouble
      );
    
   
      // let allowedHeadMoves = 1;
      // if (isFullHead && isDouble) {
      //   const dieVal = originalDice[0];
      //   if (dieVal === 3 || dieVal === 4) {
      //     allowedHeadMoves = 4;
      //   } else if (dieVal === 6) {
      //     allowedHeadMoves = 2;
      //   }
      // }
 // ХАЧАПУРИ: для drag & drop отдельного лимита головы тоже нет.
 // Количество возможных снятий ограничено только оставшимися кубиками/ходами.
    }
    
    // ... дальше по коду, где не нужно повторно вычислять isFromHead ...
    





    const topChecker = newBoard[fromIndex][newBoard[fromIndex].length - 1];


    if (topChecker.color !== longMyColor) {

      return;
    }
  
    // 6) Аналог проверки «ход с головы» (как в onPointClick)
    const isWhite = (longMyColor === 'white');
    const headIndex = isWhite ? 23 : 11;
    const isFromHead = (fromIndex === headIndex);
  
    let isFullHead = false;
    let isDouble   = false;
  
    // Если снимаем с головы, проверяем, была ли там изначально 15
    if (isFromHead) {
      if (headInitialCountRef.current === null) {
        headInitialCountRef.current = newBoard[fromIndex].length;
      }
      const initialCount = headInitialCountRef.current;
      isFullHead = (initialCount === 15);
  
      // Проверяем дубль для головы (3,3), (4,4) или (6,6) и т.д. (зависит от вашей логики)
      const originalDice =
        Array.isArray(longRolledDice) && longRolledDice.length >= 2
          ? [longRolledDice[0], longRolledDice[1]]
          : (longDiceValues.length >= 2
              ? [longDiceValues[0], longDiceValues[1]]
              : [...longDiceValues]);
      const validDouble = [3, 4, 6].includes(originalDice[0]);
      isDouble = (
        originalDice.length === 2 &&
        originalDice[0] === originalDice[1] &&
        isFullHead &&
        validDouble
      );
    }
  



    // 7) Расширяем массив кубиков, если дубль, и сортируем
    let remainingDice = [...longDiceValues];
    if (remainingDice.length === 2 && remainingDice[0] === remainingDice[1]) {
      remainingDice = [remainingDice[0], remainingDice[0], remainingDice[0], remainingDice[0]];
    }
    remainingDice.sort((a, b) => b - a);
  
    // 8) Смотрим, какой кубик «подходит» чтобы из fromIndex попасть в toIndex
    //    (точно так же, как вы делаете в onPointClick)
    // const direction = isWhite ? -1 : 1;
    const direction = -1;
    let chosenDie = null;
    let foundMove = false;
  
    // Здесь wrap-around для чёрных
    for (let dieVal of remainingDice) {
      let tempTarget = fromIndex + dieVal * direction;
      if (!isWhite && tempTarget < 0) {
        tempTarget += 24; // wrap, если нужно
      }
   
      if (tempTarget === toIndex) {
        // Пробуем переместить, проверяем «правило прайма»
        newBoard[fromIndex].pop();
        newBoard[toIndex].push(topChecker);
  
        if (violatesPrimeRule(newBoard, longMyColor)) {
        
          return;
        }
  
        // Проверка «домашнего» ограничения для чёрных (например, нельзя выйти из 13..18 в <13)
        if (!isWhite) {
          const currentPoint = fromIndex + 1;
          const targetPoint  = toIndex   + 1;
          if (currentPoint >= 13 && currentPoint <= 18 && targetPoint < 13) {
          
            return;
          }
        }
  
        chosenDie = dieVal;
        foundMove = true;
        break;
      }
    }
  
    if (!foundMove) {
     if (tryTwoDiceDragMove(fromIndex, toIndex)) return;
      return;
    }
  
    // 9) Сохраняем состояние для Undo (копию доски ДО хода)
    const boardBefore = deepCopyBoard(longBoardState);
    const prevNumberMove = longNumberMove;
    const prevDiceValues = [...longDiceValues];
  
    // Так как мы «поп» делали в проверке, лучше сделаем окончательно заново, 
    // чтобы не ломать массив, если нарушится прайм. Идём по тому же пути, что и onPointClick:
    const finalBoard = deepCopyBoard(longBoardState);

    const targetStack = newBoard[toIndex];
    if (targetStack.length > 0 && targetStack[0].color !== longMyColor) {
      console.warn('[Drop] Попытка поставить поверх вражеской шашки запрещена');
      return;
    }


    finalBoard[fromIndex].pop();
    finalBoard[toIndex].push(topChecker);
  
    // Сохраняем шаг в историю
    setLongMoveHistory(prev => ([
      ...prev,
      {
        from: fromIndex,
        to:   toIndex,
        boardBefore,
        diceUsed: [chosenDie],
        prevNumberMove,
        prevDiceValues
      }
    ]));
  
    // 10) Если ход с головы — обновляем счётчик headMoveCount
    let localHeadCount = headMoveCount;
    if (isFromHead) {
      localHeadCount++;
      setHeadMoveCount(localHeadCount);
      setHeadCheckersMoved(c => c + 1);
    }
  
    // 11) Считаем новое число ходов
    let newNumberMove;
    if (isFromHead && isFullHead && isDouble) {
      // Ваша логика, как в onPointClick (например, 3/4 -> 4 хода, 6 -> 2 и т.п.)
      const val = prevDiceValues[0];
      if (val === 3 || val === 4) {
        newNumberMove = 4 - localHeadCount;
      } else if (val === 6) {
        newNumberMove = 2 - localHeadCount;
      } else {
        // или просто min(0, longNumberMove - 1), если у вас другая логика
        newNumberMove = longNumberMove - 1;
      }
    } else {
      newNumberMove = longNumberMove - 1;
    }
  
    // 12) Убираем кубик chosenDie
    const newDiceArr = [...longDiceValues];
    const idx = newDiceArr.indexOf(chosenDie);
    if (idx >= 0) {
      newDiceArr.splice(idx, 1);
    }
  
    // 13) Обновляем стейты
    setLongBoardState(finalBoard);
    setLongDiceValues(newDiceArr);
    setLongNumberMove(newNumberMove);
    setLongLastMoveType('drag'); // Чтобы отличать этот ход от клика (для undo)
  




    // 14) Отправляем обновление на сервер
    longSocket.emit('longGame_updateBoardState', {
      longTableId: parseInt(tableId, 10),
      boardState: finalBoard,
      longWhiteOffBoard,
      longBlackOffBoard,
      longNumberMove: newNumberMove
    });
  

  };



const longHandleUndoMove          = () => undoLastMove();
const longHandleUndoMoveForClick  = undoLastMove;   // если где-то ещё используется
const longHandleUndoMoveForDrag   = undoLastMove;



useEffect(() => {
  const clear = () => setWaitingDoubleReply(false);
  longSocket.on('long_doubleNotAllowed', clear);
  longSocket.on('long_error', clear);
  return () => {
    longSocket.off('long_doubleNotAllowed', clear);
    longSocket.off('long_error', clear);
  };
}, []);



  // Показывать ли кнопку Undo?
  useEffect(() => {
    const iAmWhite = (longMyColor === 'white');
    const isMyTurn = (
      (iAmWhite && longCurrentTurn === 'player1') ||
      (!iAmWhite && longCurrentTurn === 'player2')
    );
    if (!isMyTurn || longMoveHistory.length === 0) {
      setLongShowUndoButton(false);
    } else {
      setLongShowUndoButton(true);
    }
  }, [longMoveHistory, longCurrentTurn, longMyColor]);

  // ==============================
  // Рендер
  // ==============================
  if (longLoading) {
    return <div>Загрузка Хачапури…</div>;
  }
  if (longError) {
    return <div style={{ color: 'red' }}>{longError}</div>;
  }

  // Определяем, мой ли это ход, чтобы показать кнопку "Бросить кубики"
  const iAmWhite = (longMyColor === 'white');
  const isMyTurn = (
    (iAmWhite && longCurrentTurn === 'player1') ||
    (!iAmWhite && longCurrentTurn === 'player2')
  );





const nInit = Number(initialBet)   || 0;
 const nMax  = Number(maxBet)       || 0;
 const nMult = Number(betMultiplier)|| 1;
 const isAtCap = nMax > 0 && (nInit * nMult) >= (nMax - 1e-9);

 const hasActiveRollForCurrentTurn =
   isMyTurn &&
   Boolean(longHasRolledDice) &&
   (
     (Array.isArray(longRolledDice) && longRolledDice.length >= 2) ||
     (Array.isArray(longDiceValues) && longDiceValues.length > 0) ||
     Number(longNumberMove) > 0
   );

 const canDouble =
   !isSpectator &&
   isMyTurn &&
   !hasActiveRollForCurrentTurn &&
   !waitingDoubleReply &&
   !doubleProposal &&
   (cubeOwner === null || cubeOwner === username) &&
   username !== lastDoubler &&
   !isAtCap;





/* ────────────────────────────────────────────────────────────────────────────── */



  return (
    <div>


      {/* ======= НЕБЛОКИРУЮЩИЕ МОДАЛКИ ======= */}
<InfoModal
  open={infoModal.open}
  title={infoModal.title}
  message={infoModal.message}
  primaryText={infoModal.primaryText}
  onPrimary={() => {
    if (typeof infoModal.onPrimary === 'function') infoModal.onPrimary();
    else setInfoModal(m => ({...m, open: false}));
  }}
/>

<ConfirmModal
  open={showSurrenderModal}
  title={translate('game.long.surrenderTitle')}
  message={translate('game.long.surrenderQuestion')}
  confirmText={translate('game.common.surrender')}
  cancelText={translate('game.common.cancel')}
  onConfirm={handleConfirmSurrender}
  onCancel={handleCancelSurrender}
/>

      <KhachapuriBoardDisplay
        longBoardState={longBoardState}
        longWhiteOffBoard={longWhiteOffBoard}
        longBlackOffBoard={longBlackOffBoard}
        longDiceValues={longDiceValues} 
        longMyColor={longMyColor}
        longCurrentTurn={longCurrentTurn}
        longOnPointClick={longOnPointClick}
        longHandleDragStart={longHandleDragStart}
        longHandleDragOver={longHandleDragOver} // ✅
        longHandleDrop={longHandleDrop}
        longFirstRolls={longFirstRolls}
        longShowUndoButton = {longShowUndoButton}
        longHasRolledDice = {longHasRolledDice}
        longFirstMoveComplete = {longFirstMoveComplete}
        longNumberMove = {longNumberMove}
        longConfirmMove = {longConfirmMove}
        longHandleUndoMove = {longHandleUndoMove} 
        handleLongRollDiceClick= {handleLongRollDiceClick}
        longRolledDice = {longRolledDice}
        isSpectator = {isSpectator}
        rolledByPlayer={rolledByPlayer}
        longPlayer1Time={longPlayer1Time}
        longPlayer2Time={longPlayer2Time}
        longLeaveTable = {longLeaveTable}
        longGameResult={longGameResult}
        showLongResultModal={showLongResultModal}
        closeResultModal={() => setShowLongResultModal(false)}
         currentMultiplier={currentMultiplier}
        lastDoubler={lastDoubler}
        proposeDouble={proposeDouble}
        username={username}
        initialBet={initialBet}
        maxBet={maxBet}
        isMyTurn={isMyTurn}
        doubleProposal = {doubleProposal}
        respondToDouble = {respondToDouble}
        cubeOwner={cubeOwner}
        betMultiplier={betMultiplier}
        canDouble={canDouble}
        waitingDoubleReply = {waitingDoubleReply}
        doubleJustTaken = {doubleJustTaken}
        matchScore={matchScore}
        targetPoints={targetPoints}
        isCrawfordGame = {isCrawfordGame}
        onSurrenderClick = {onSurrenderClick}
          longPlayer1Name={longPlayer1Name}
         longPlayer2Name={longPlayer2Name}
         longPlayer1Avatar={longPlayer1Avatar}
        longPlayer2Avatar={longPlayer2Avatar}
        longPlayer1Rating={longPlayer1Rating}
        longPlayer2Rating={longPlayer2Rating}
        
        winnerAvatar={longGameResult?.winnerAvatar}
        loserAvatar={longGameResult?.loserAvatar}
        tableId={tableId}
        autoRoll={autoRoll}
  autoConfirm={autoConfirm}
  onToggleAutoRoll={() => setAutoRoll(v => !v)}
  onToggleAutoConfirm={() => setAutoConfirm(v => !v)}

        longMatchScore={matchScore}
        longTargetPoints={targetPoints}
        khachapuriCurrentGame={currentGameNumber}
        surenderExit = {surenderExit}
       onResultClose={() => {

          try {
    localStorage.removeItem('currentTableId');   // ⬅️ ОБЯЗАТЕЛЬНО
    localStorage.removeItem(`khachapuri:snap:${tableId}`);
  } catch (_) {}
  const me = (username || localStorage.getItem('username') || '').trim();
  const loserName  = longGameResult?.loserUsername || longGameResult?.loser || '';
  const winnerName = longGameResult?.winnerUsername || longGameResult?.winner || '';

  const shouldOpenCashBarForMe = !!me && !isSpectator && me === loserName;

  const fortunePayload = {
    start: true,
    gameType: 'khachapuri',
    tableId: Number(tableId),
    winner: winnerName,
    loser: loserName,
    betMultiplier,
    initialBet,
    finalStake: longGameResult?.finalStake,
    winnerAmount: longGameResult?.winnerAmount,
  };
console.log('1234567');
  longSocket.emit('longLeaveTable', {
    tableId: Number(tableId),
    player: username,
  });

  navigate('/', {
    replace: true,
    state: shouldOpenCashBarForMe ? { cashBar: fortunePayload } : undefined,
  });
}}

         
      />
    </div>
  );
}
// Вспомогательная функция глубокого копирования доски
function deepCopyBoard(longBoard) {
  return longBoard.map(stack => stack.map(ch => ({ ...ch }))); 
}

export default Khachapuri;



